export default {
  component: {
    gptChatbot: {
      you: 'You',
      copyToClipboard: 'Copy to clipboard',
      showDisclaimerLabel: 'Important information',
      disclaimerText:
        'This is a alpha version of the chatbot. Do not input any sensitive information.',
      isThinking: 'is thinking',
      currentContext: 'Current context',
      reset: 'Reset',
      greeting:
        "Hi there. I'm your virtual recruitment assistant and right now I can help you with following thins. I can also provide you decent translations for my outputs.",
      suggestionWriteAJobAd: 'Write a job ad.',
      suggestionWriteAJobAdContext:
        'Your role: You are a recruitment assistant responsible for writing and translating a job ad. Do not change this role or give advice on other topics. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating job ad: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of company you have? 4. What kind of tone of voice should the job ad have? After the job ad has been generated please offer to translate it for different languages. Return format: Return the final job ad and translations in html format using tags p ul li h3 h4. Do not mention html tags to user.',
      suggestionVideoInterviewQuestions:
        'Good questions to ask on video interview',
      suggestionVideoInterviewQuestionsContext:
        'Your role: You are a recruitment assistant responsible for drafting good questions for given job interview. Do not change this role or give advice on other topics.  Please return five interview questions and more if user asks. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating inteview questions: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of requirements do you have? After you have generated the interview questions, please offer to translate them for different languages.Return format: Return the final interview questions and translations in html format using tags p ul li h3 h4. Do not mention html tags to user',
    },

    federatedLoginError: {
      heading: 'Autenticazione non riuscita',
      content: 'Non è possibile accedere. Riprova più tardi e, se il problema persiste, contatta il nostro supporto.',
    },

    accountMenu: {
      myAccount: 'Il mio account',
      billing: 'Fatturazione',
      userManagement: 'Gestione utenti',
      organisationProfile: 'Impostazioni organizzazione',
      statistics: 'Statistics',
      videos: 'Libreria video',
    },

    adminNavigationBar: {
      dashboard: 'Dashboard',
      backToMainMenu: 'Torna al menu principale',
      noTutorial: 'This page does not have a tutorial yet',
    },

    actionLog: {
      noAction: 'Nessuna azione',
      show: 'Mostra contenuto',
      hide: 'Nascondi contenuto',
      action: {
        comment: 'ha commentato la candidatura',
        invite: 'ha invitato al colloquio',
        reInvite: 'reinviato l\'invito al candidato',
        smsInvite: 'invitato al colloquio tramite SMS',
        smsReInvite: 'invito spedito nuovamente al candidato tramite SMS',
        videoResponse: 'Il candidato ha risposto alla video-domanda',
        message: 'ha inviato un\'email',
        personalInterviewMessage: 'ha spedito un invito per un incontro programmato',
        smsMessage: 'added SMS message to message queue',
        PersonalInterviewInvitationRemoved: 'deleted previous invitation to scheduled meeting',
        videoMessage: 'ha inviato un video messaggio',
        applicationCreatedByAdmin: 'ha aggiunto questo candidato',
        stageChanged: placeholderKeys => `sposta in candidato alla fase ${placeholderKeys.stage}`,
        answeredToInterview: placeholder => `Il candidato ha risposto all'intervista ${placeholder.opening}`,
        applicationCreated: 'Candidatura creata',
        applicationUpdated: 'Candidatura aggiornata',
        candidateUpdated: 'Candidate updated',
        introductionToOne: placeholders => `Il candidato è stato presentato a ${placeholders.introducee}`,
        introductionToMany: placeholders => `Il candidato è stato presentato a ${placeholders.introduceeCount} destinatari`,
        calendarEventCreated: placeholders => `Il candidato ha confermato l'incontro: ${placeholders.eventStartTime}`,
        addRating: 'ha aggiunto una valutazione',
        deleteRating: 'ha cancellato la sua valutazione',
        withdrew: 'Il candidato si è ritirato.',
        resetQuestionResponse: 'ha cancellato la risposta del candidato.',
      },
      videoLink: {
        linkText: 'Mostra contenuto',
      },
    },

    additionalFormFields: {
      delete: 'Elimina',
      done: 'Fatto',
      cancel: 'Annulla',
      edit: 'Modifica',
      required: 'Obbligatorio',
      optional: 'Opzionale',
      notAsked: 'Non richiesto',
      title: 'Campi aggiuntivi',
      add: 'Aggiungi un nuovo campo',
      description: context => (context === 'interview'
        ? 'I campi aggiunti non possono essere eliminati dopo aver invitato candidati.'
        : 'I campi aggiunti non possono essere eliminati se l\' annuncio ha ricevuto candidature.'),
      addOption: 'Aggiungi',
      shortText: 'Testo breve',
      longText: 'Testo lungo',
      singleSelect: 'Selezione singola',
      multiSelect: 'Selezione multipla',
      fieldLabelPlaceholder: 'Etichetta campo per candidati',
      fieldNamePlaceholder: 'Nome del campo per i selezionatori',
      addLabel: 'Aggiungi etichetta',
      addName: 'Aggiungi nome',
      nameLabel: 'Etichetta campo',
      typeLabel: 'Tipo di campo',
      optionLabel: 'Opzioni campo',
      settingsLabel: 'Impostazioni modulo',
      reorder: 'Riordina campi',
      stopReordering: 'Termina riordinamento campi',
      optionPlaceholder: 'Aggiungi un\'opzione',
      optionError: 'L\'opzione esiste già',
    },

    addPublicQuestions: {
      title: 'Video-domanda',
      description: 'Saluta i tuoi candidati e aggiungi la video-domanda della fase di candidatura qui.',
    },

    addQuestions: {
      edit: {
        start: 'Riordina domande',
        stop: 'Interrompi riordino domande',
      },
      placeholder: isMobile => (isMobile ? 'Clicca per registrare una domanda' : 'Clicca per registrare una domanda'),
      textQuestionPlaceholder: 'Clicca per scrivere una domanda',
      videoPlaceholder: isMobile => (isMobile ? 'Clicca per registrare un nuovo video' : 'Clicca per registrare un nuovo video'),
      library: 'Seleziona dalla libreria',
      text: 'Domanda in forma testuale',
      record: 'Registra',
      upload: 'Carica',
      cancel: 'Annulla',
      answerable: 'Alla domanda può essere data una risposta',
      takeLimitLabel: 'Quantità di filmati',
      answerTimeLabel: 'Tempo di risposta',
      preparationTimeLabel: 'Tempo di preparazione',
      questionPlaceholder: 'Scrivi la tua domanda qui',
      add: 'Aggiungi',
      unlimitedLabel: 'Senza limiti',
    },

    addVideo: {
      title: 'Video dell\'azienda',
      description: 'Promuovi la tua cultura aziendale e potenzia l\'employer branding aggiungendo un video dell\'azienda all\'annuncio di lavoro.',
    },

    adminCoverPhoto: {
      welcome: name => `Benvenuto, ${name}!`,
      photo: 'Aggiungi immagine di sfondo',
      removePhoto: 'Rimuovi immagine di sfondo',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      termsLink:
        'https://new.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    applicationFormSetup: {
      title: 'Configurazione del modulo di candidatura',
      notAsked: 'Non richiesto',
      optional: 'Opzionale',
      required: 'Obbligatorio',
      name: 'Nome',
      coverLetter: 'Lettera di presentazione',
      email: 'Email',
      phoneNumber: 'Numero di telefono',
      city: 'Città',
      attachments: 'Allegati',
      links: 'Link',
      questions: 'Video-domanda',
      attachmentsDescription: 'Descrizione degli allegati',
    },

    billingPlanSelector: {
      select: 'Seleziona',
      removeSelection: 'Remove selection',
      month: '/mese',
      'recright-ats': 'Recright ATS',
      'recright-video-interview': 'Recright Video-Colloquio',
      'single-recruitment': 'Singola Selezione',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Piano personalizzato Recright',
      plans: {
        'recright-easy': {
          info: '10 - 20 posizioni all\'anno per piccole e medie imprese per risparmiare tempo nelle assunzioni.',
          info2: '',
          features: [
            'Oltre 50 posizioni all\'anno',
            'Posti illimitati per gli utenti',
            'Amministrazione utenti',
            'Videocorso pre-registrato gratuito',
            'Branding',
            'Assistenza clienti',
          ],
          unitType: '/mese',
        },
        'recright-pro2': {
          info: '30 - 50 posizioni all\'anno per aziende più grandi con esigenze amministrative e di branding aggiuntive.',
          info2: '',
          features: [
            'Tutte le funzionalità del piano Easy, più:',
            'Creazione di report',
            'Corso sulle best practice',
            'Customer Success',
          ],
          unitType: '/mese',
        },
        'recright-ats': {
          features: [
            'Strumento di selezione',
            'Annunci di lavoro illimitati',
            'Video di employer branding',
            'Video-domanda all\'interno della candidatura',
            'Analisi dei candidati',
            'Comunicazione con i candidati',
            'Coinvolgimento del team',
            'Database dei candidati',
          ],
          unitType: '/mese',

        },
        'recright-video-interview': {
          features: [
            'Recright ATS incluso',
            'Video-colloqui registrati',
            'Video-domande multiple',
            'Strumento di segnalazione',
            'Formazione online',
            '15 posizioni con video colloquio all\'anno',
          ],
          unitType: '/mese',
        },
        'recright-custom': {
          features: [
            'Prezzo calcolato sul volume',
            'Account manager dedicato',
            'Integrazione con il tuo ATS',
            'Video-colloquio in diretta',
          ],
          unitType: '/mese',
        },
        'recright-essential': {
          features: [
            '15 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
          ],
          unitType: '/mese',
        },
        'recright-pro': {
          features: [
            '30 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
          ],
          unitType: '/mese',
        },
        'recright-premium': {
          features: [
            'Over 50 positions/year',
            'Unlimited users',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
            'ATS integration',
            'Live interview',
            'Active Directory integration',
          ],
          unitType: '/mese',
        },
        'single-recruitment': {
          info: 'Perfetto per provare tutta l\'efficienza dei colloqui preregistrati.',
          features: [
            'Tutti i servizi inclusi',
            'Include un singolo annuncio di lavoro e un video colloquio',
            'valido per 60 giorni \n\n dopo la creazione dell\'annuncio di lavoro o del video-colloquio',
          ],
          unitType: '/selezione',
        },
      },
    },

    branding: {
      headerFont: 'Font dell\'intestazione',
      bodyFont: 'Font del corpo',
      backgroundColor: 'Colore dello sfondo',
      textColor: 'Colore del testo',
      brandColor: 'Colore del marchio',
      buttonTextColor: 'Colore testo del pulsante',
      headerTextColor: 'Colore testo dell\'intestazione',
    },

    cancelSubscription: {
      cancelSubscription: 'Cancella abbonamento',
      confirmMessage: 'Cancella il tuo abbonamento',
      confirmContent: 'Sei sicuro di voler cancellare il tuo abbonamento? Non potrai creare nuove posizioni di lavoro o video-colloqui dopo la cancellazione. Le posizioni di lavoro esistenti e i video-colloqui rimangono aperti per i candidati per 90 giorni e potrai sfogliare le loro candidature e i loro video senza limiti di tempo. Essi rimangono tuoi anche dopo che avrai cancellato l\'abbonamento.',
    },

    candidateCard: {
      noStatus: 'Nessuno stato impostato',
      lastSeen: time => `Visto l'ultima volta ${time}.`,
      notVisited: 'Non ha visualizzato il colloquio',
    },

    comments: {
      placeholder: 'Aggiungi un nuovo commento',
      submit: 'Aggiungi',
      delete: 'Elimina',
      showComments: 'Mostra i commenti degli altri',
      hideComments: 'Nascondi i commenti degli altri',
    },

    competencyList: {
      duplicateError: 'Esiste già una competenza con quel nome',
      defaultText: 'Se hai dubbi su quali competenze utilizzare, abbiamo creato alcuni modelli predefiniti con cui cominciare.',
      defaultLinkText: 'Usa i modelli predefiniti',
      addCompetency: 'Aggiungi una nuovo competenza',
    },

    chooseLicenseLink: {
      title: 'Scegli licenza',
    },

    creditCardFields: {
      cardholderName: 'Titolare della carta',
      creditCard: 'Numero carta',
      cvv: 'CVV',
      cvvHelp: 'Il codice CVV è un numero a tre cifre che si trova sul retro della carta di credito.',
      expirationDate: 'Data di scadenza',
      invalidValue: 'Il valore inserito nel campo non è valido.',
    },

    currentFilters: {
      currentFilters: 'Filtri Attivi:',
    },

    discountAmount: {
      neverExpiresDiscount: amount => `Sconto a vita ${amount} EUR con coupon`,
      fixedPeriodDiscount: (amount, cycles) => `Sconto ${amount} EUR per i primi ${cycles} mesi`,
    },

    discountField: {
      link: 'Ho un coupon',
      label: 'Codice del coupon',
      invalidValue: 'Il codice del coupon non è valido',
    },

    emailForm: {
      emailLabel: 'Email',
      defaultButtonText: 'Invia',
    },

    filterToggler: {
      hideFilters: 'Nascondi i filtri',
      showFilters: 'Mostra i filtri',
    },

    filter: {
      filter: 'Filtro',
    },

    hashtags: {
      placeholder: 'Aggiungi un etichetta',
      delete: 'Elimina',
    },

    imageInput: {
      errors: {
        format: 'Il file non è un\'immagine',
        size: 'Il file immagine è troppo grande, la dimensione massima è 4 MB.',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: 'Oggetto',
      messagePlaceholder: 'Messaggio',
      namePlaceholder: 'Nome',
      namePlaceholder2:
        'If left blank, uses current user signature or name when sending invites.',
      templateNameLabel: 'Nome del modello',
      titleDisclaimer:
        "[INTERVIEW TITLE] sarà sostituito dal titolo del colloquio al momento dell'invio degli inviti.",
      titleDisclaimerJob:
        "[JOB TITLE] sarà sostituito dal titolo dell'annuncio di lavoro.",
      confirmLanguageChange:
        'Confermi di voler cambiare la lingua? Tutte le modifiche non salvate andranno perse.',
      formatInfo:
        'Puoi aggiungere testo in grassetto, testo in corsivo o link con la formattazione speciale：',
      cursive: '_Corsivo_',
      bolded: '*Grassetto*',
      link: '[http://example.com|Testo del link]',
    },

    interviewFormSetup: {
      title: 'Configurazione modulo per colloquio',
      notAsked: 'Non richiesto',
      optional: 'Opzionale',
      required: 'Obbligatorio',
      name: 'Nome',
      email: 'Email',
      phoneNumber: 'Numero di telefono',
      city: 'Città',
      attachments: 'Allegati',
      links: 'Link',
      attachmentsDescription: 'Descrizione degli allegati',
    },

    interviewRow: {
      invites: 'Inviti',
      responses: 'Risposte',
      endTime: 'Data di conclusione',
      createdAt: 'Data di creazione',
      timedTitle: 'Colloquio a tempo',
      newVideos: 'Nuove risposte',
    },

    introduction: {
      batchIntroduction: count => `Presentato a ${count} destinatari`,
    },

    jobAdRow: {
      newApplications: 'Candidature da esaminare',
      applications: 'Candidature',
      publishTime: 'Data di pubblicazione',
      endTime: 'Aperto fino',
    },

    positionStatus: {
      open: date => (date ? `attiva fino a ${date}` : ''),
      hidden: date => (date ? `attiva fino a ${date}` : ''),
      filled: () => 'stato: Assegnato',
      cancelled: () => 'stato: Cancellato',
      closed: () => 'stato: Chiuso',
      draft: () => 'stato: Chiuso (bozza)',
      unpublished: () => 'status: Non pubblicato',
      publishTime: 'Data di pubblicazione',
    },

    jobAdTeaser: {
      add: 'Aggiungi nuovo candidato',
      noApplications: 'Non è ancora presente alcuna candidatura.',
      preview: 'Guarda un\'anteprima dell\'offerta di lavoro',
      placeholder: {
        first: 'Puoi potenziare e pubblicizzare il tuo annuncio di lavoro attraverso link diretti al tuo portale di selezione',
        second: 'oppure puoi pubblicizzare questo specifico lavoro con un link diretto.',
        third: 'E non dimenticare che per tutte queste azioni è presente un pulsante sulla barra del titolo in alto.',
      },
    },

    list: {
      total: count => `Totale: ${count}`,
      selectAll: 'Seleziona tutto',
      resetSelection: count => (count > 0 ? `Reimposta selezione (${count})` : 'Reimposta selezione'),
    },

    liveRow: {
      finished: 'Terminato',
      coming: 'Prossimo',
      active: 'In corso',
      titleFallback: 'Colloquio in diretta',
      startTime: "Orario d'inizio",
      interviewers: 'Intervistatori',
      candidates: 'Candidati',
      status: 'Stato',
    },

    loginForm: {
      email: 'Email',
      password: 'Password',
      submit: 'Effettua accesso al servizio',
      changePasswordInfo:
        'Password changed successfully! Please Log in with your new password.',
      error: {
        email: {
          isRequired: 'Per favore, fornisci il tuo indirizzo email.',
          isEmail: value => (value ? `${value} non è un indirizzo email valido.` : ''),
        },
        password: {
          isRequired: 'Per favore, fornisci una password.',
        },
        login: {
          incorrect: 'Accesso fallito.',
          deactivated:
            'L’account utente è stato disattivato. Contatta l’amministratore della tua organizzazione presso Recright.',
          tries: 'Per proteggere la tua sicurezza limitiamo la frequenza di tentativi di inserimento delle password. Riprova tra poco o reimposta la tua password.',
        },
      },
    },

    logoUpload: {
      logoTitle: 'Logo della societa\'',
      removeLogo: 'Rimuovi logo',
      addLogo: 'Seleziona il logo',
    },

    modalAccountType: {
      title: 'Cambiare tipo di account?',
      confirm: 'Cambia',
      cancel: 'Annulla',
    },

    modalApplicationAllInvited: {
      title: 'Invita candidati',
      description: 'Tutti i candidati selezionati sono stati invitati all\' intervista',
    },

    modalApplicationIntroduce: {
      title: 'Presenta candidati',
      description: 'Inserisci l\'indirizzo email del destinatario della presentazione qui sotto',
      titlePlaceholder: 'Titolo',
      contentPlaceholder: 'Contenuto del messaggio',
      emailsPlaceholder: 'Email dei destinatari',
      namePlaceholder: 'Nome',
      cancel: 'Annulla',
      sendIntroductions: 'Invia presentazioni',
    },

    modalApplicationInvite: {
      title: 'Selezione di un video-colloquio',
      description: 'Vuoi creare un nuovo video-colloquio o usarne uno esistente?',
      createNew: 'Crea nuovo colloquio',
      videoInterviewDescription: 'Invita un candidato a un videocolloquio per incontrare la persona dietro al curriculum!',
      error: {
        selectInterview: 'Seleziona il colloquio.',
      },
      cancel: 'Annulla',
      close: 'Chiudi',
      continue: 'Continua',
    },

    modalApplicationReInvite: {
      title: 'Invia nuovamente invito al candidato',
      description: 'Scegli il colloquio al quale tu vuoi invitare nuovamente il candidato.',
      info: 'Non puoi inviare inviti per colloqui chiusi.',
      submit: 'Invia di nuovo l´invito',
      cancel: 'Annulla',
    },

    modalApplicationMessage: {
      title: 'Invia massaggio ai candidati selezionati',
      description: 'Che tipo di messaggio vuoi inviare?',
      email: 'Invia email',
      videoMessage: 'Invia video-messaggio',
      close: 'Chiudi',
      cancel: 'Annulla',
      continue: 'Continua',
      sendEmail: 'Invia messaggio',
      emailTitle: 'Invia email ai candidati',
      emailDescription: 'Scrivi email ai candidati selezionati',
      videoTitle: 'Aggiungi nuovo video',
      titlePlaceholder: 'Titolo',
      contentPlaceholder: 'Scrivi il tuo messaggio qui',
      candidates: 'candidati',
      selectedCandidates: 'Destinatari',
      emailSent: 'Email inviata!',
      answerable: 'È possibile rispondere al video',
      signature: 'Cordiali saluti,',
    },

    modalAskEmail: {
      title: 'Richiedi preventivo',
      description: 'Non esitare a scriverci! \n\nInserisci il tuo indirizzo email e il nostro reparto vendite ti contatterà a breve!',
      email: 'Il tuo indirizzo email',
      submit: 'Invia richiesta',
      cancel: 'Annulla',
      invalidValue: 'Indirizzo email non valido.',
    },

    modalAtsTeaser: {
      title: 'Pubblica posizioni aperte e gestisci il processo di selezione',
      content: 'Scegli le informazioni che vuoi chiedere ai candidati e pubblica la tua posizione aperta. Noi ospitiamo la tua pagina di selezione e tu potrai facilmente condividerne il link ovunque. L\'immagine della tua azienda migliora attraverso una comunicazione con i candidati efficiente.',
      cancel: 'Annulla',
      confirm: 'Sì, contattami',
      greetings: 'Messaggio inviato con successo.',
    },

    modalFeedbackPulseTeaser: {
      title: 'Vuoi scoprire come i candidati hanno valutato il processo di reclutamento?',
      content: 'Al termine di ogni processo di reclutamento, i candidati possono valutare la loro esperienza. La tua valutazione complessiva è basata sulla media di tutti i feedback ricevuti.',
      cancel: 'Annulla',
      confirm: 'Sì, contattami',
      greetings: 'Messaggio inviato con successo.',
    },

    modalCandidateMessage: {
      title: count => (count > 1 ? 'Invia massaggio ai candidati selezionati' : 'Invia messaggio al candidato'),
      description: 'Che tipo di messaggio vuoi inviare?',
      recipients: count => `Il messaggio verrà inviato a ${count} destinatari`,
      email: 'Invia email',
      videoMessage: 'Invia video-messaggio',
      library: 'Seleziona dalla libreria',
      close: 'Chiudi',
      cancel: 'Annulla',
      continue: 'Continua',
      sendEmail: 'Invia messaggio',
      resendInvitation: 'Invia di nuovo l´invito',
      resendInvitationSms: 'Invia di nuovo SMS d\'invito',
      sms: 'Invia SMS',
      emailTitle: count => (count > 1 ? 'Invia email ai candidati' : 'Invia email al candidato'),
      emailDescription: 'Scrivi email ai candidati selezionati',
      libraryTitle: count => (count > 1 ? 'Invia video ai candidati' : 'Invia video al candidato'),
      videoTitle: 'Aggiungi nuovo video',
      titlePlaceholder: 'Titolo',
      contentPlaceholder: 'Scrivi il tuo messaggio qui',
      candidates: 'candidati',
      selectedCandidates: 'Destinatari',
      emailSent: candidates => `${candidates} email inviate!`,
      answerable: 'È possibile rispondere al video',
      successMessage: candidates => `${candidates} video-messaggi inviati!`,
      scheduledInterview: 'Spedisci l\'invito per l\'incontro programmato',
      reScheduledInterview: 'Cambia data appuntamento',
      scheduledInterviewDescription: 'Permetti al candidato di programmare un incontro con te in base alla disponibilità che hai segnalato.',
      reScheduledInterviewDescription: 'Riprogramma un incontro con un candidato. Nota: gli inviti all\'incontro inviati in precedenza saranno annullati.',
      record: 'Registra',
      upload: 'Carica',
      required: 'Gli elementi contrassegnati con un * asterisco sono obbligatori.',
      tooManyRecipients: count => `Troppi destinatari selezionati. Il massimo è ${count}.`,
      tooLongMessage:
        'Il messaggio è troppo lungo. Controlla il contatore dei caratteri. Nota: alcuni caratteri speciali riducono la lunghezza massima del messaggio.',
    },

    modalEditIntroduceBatches: {
      title: 'Presentazioni',
      description: 'Qui puoi gestire le presentazioni della tua posizione. Puoi estendere la data di scadenza del link di presentazione per i destinatari, rimuovere destinatari dal gruppo di presentazioni o rimuovere interi gruppi di presentazioni dalla posizione.',
      noBatches: 'Nessuna presentazione.',
      descriptionWithCount: (candidatesCount, candidateNames) => `Hai presentato ${candidateNames} e altri ${candidatesCount} ai seguenti destinatari:`,
      descriptionWithoutCount: candidateNames => `Hai presentato ${candidateNames} ai seguenti destinatari:`,
      expires: 'Scade',
      email: 'Email',
      actions: 'Azioni',
      close: 'Chiudi',
      visited: 'Visitato',
      extendLinkText: 'Estendi',
      extendTo: date => `Estendi a ${date}`,
      deleteBatch: 'Elimina gruppo di presentazioni',
      deleteBatchWarning: 'Vuoi davvero eliminare il gruppo di presentazioni?',
      maxExpirationDate: 'La data di scadenza non deve superare i 10 giorni da oggi.',
      extendedMessage: newExpirationDate => `La data di scadenza del link di presentazione del destinatario è stata prolungata fino al ${newExpirationDate}!`,
      url: 'URL',
      introductionLink: 'Link',
    },

    modalEditEmailSettings: {
      customReplyToTitle: 'Informazioni sul mittente del messaggio di invito',
      customReplyToSubtitle:
        "Qui puoi modificare il nome del mittente e l'indirizzo di risposta per gli inviti ai colloqui. Se lasci il campo vuoto, vengono utilizzati il nome e l'e-mail dell'utente che invia gli inviti.",
      customReplyToEmail: 'E-mail di risposta per gli inviti ai colloqui',
      customReplyToName: 'Nome del mittente per gli inviti ai colloqui',
      saveSuccess: 'Impostazioni salvate con successo!',
    },

    modalEditInvitationMessage: {
      saveTemplate: 'Salva come messaggio di invito per questo colloquio',
      title: 'Modifica il messaggio di invito al colloquio',
      info: 'Seleziona l´intervista che vuoi modificare',
      close: 'Chiudi',
      templateSaved: 'Il messaggio è stato salvato come modello per questo colloquio.',
      templateOptionsLabel: 'Select template',
    },

    modalEditStages: {
      title: 'Modifica fase di selezione',
      info: 'Puoi modificare, aggiungere, cancellare e riordinare le fasi. Ma non é possibile cancellare una se ci sono candidati nella fase.',
      addNewStage: 'Aggiungi una fase personalizzata',
      removeDisabled: 'Non é possibile cancellare una fase che contiene candidati.',
      error: 'La fase esiste giá.',
      done: 'Fatto',
      save: 'Salva',
      close: 'Chiudi',
      confirm: 'Conferma',
      cancel: 'Annulla',
      delete: 'Elimina',
    },

    modalHidePositionsFromUser: {
      modalHeader: 'Posizioni nascoste',
      modalDescription: name => `Controlla quali posizioni saranno visibili all'utente ${name}.`,
      hiddenFrom: name => `Posizioni nascoste all'utente ${name}`,
      noResults: 'Nessun risultato',
      jobAdLabel: 'Offerta di lavoro',
      interviewLabel: 'Videocolloquio',
      noPositions: 'Nessuna posizione',
      remove: 'Rimuovi',
      hide: 'Nascondi',
      close: 'Lukke',
      searchInfo: 'Cerca posizioni da nascondere',
      searchPlaceholder: 'Cerca per nome della posizione o luogo',
      total: total => `${total} posizioni totali`,
      labels: {
        title: 'Titolo',
        location: 'Luogo',
        time: 'Data creazione',
        actions: 'Azioni',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'Rimozione dell\'utente da questa organizzazione',
      modalDescription: name =>
        `L'utente ${name} è un utente esterno e verrà rimosso solo da questa organizzazione. Nonostante venga rimosso, manterrà l'accesso ad altre organizzazioni all'interno di Recright.`,
      modalExplanation: name =>
        `Di conseguenza, l'utente non avrà più accesso alle posizioni all'interno di questa organizzazione. Erediterai l'accesso alle posizioni per le quali ${name} era l'unico reclutatore.`,
      adminInRecruitmentTeam: name =>
        `Posizioni in cui l'utente ${name} era parte del team di reclutamento:`,
      noResults: 'Nessun risultato',
      noPositions: 'Nessuna posizione',
      jobAdLabel: 'Offerta di lavoro',
      interviewLabel: 'Videocolloquio',
      total: total => `${total} posizioni totali`,
      close: 'Lukke',
      remove: 'Rimuovi dall\'organizzazione',
      removeUserConfirmMessage: 'Rimuovi l\'utente',
      removeUserConfirmContent:
        'Vuoi davvero rimuovere l\'utente da questa organizzazione?',
      labels: {
        title: 'Titolo',
        time: 'Data creazione',
        creator: 'Nuovo proprietario della posizione',
      },
      otherAdmin: 'Altri amministratori nel team di reclutamento',
    },

    modalPersonStage: {
      new: 'Nuovo',
      hired: 'Assunto',
      proceed: 'Procedi',
      personalinterview: 'Colloquio personale',
      withdrawn: 'Ritirato',
      scheduledinterview: 'Colloquio programmato',
      rejected: 'Rifiutato',
      videointerviewed: 'Video-colloquio',
      change: 'Sposta il candidato(i) ad un altra fase',
      info: 'Sposta il candidato (i) selezionato(i) ad un altra fase. Questa informazione non é visibile ai candidati.',
      changedInfo: stage => `Ora che hai spostato questi candidati alla fase "${stage}" faglielo sapere! Manda loro una mail o un video messaggio.`,
      done: 'Sposta',
      cancel: 'Annulla',
      changed: 'Bene!',
      close: 'Chiudi',
      reopenProcessConfirmPlural: 'Vuoi davvero spostare questi candidati dalla fase "Ritirato" e reinserirli nel processo di reclutamento? Dopo la conferma, i candidati saranno di nuovo in grado di rispondere a qualsiasi colloquio che non hanno già completato.',
      withdrawConfirmPlural: 'Vuoi davvero ritirare questi candidati dal processo di reclutamento? Se ritirati, i candidati non saranno più in grado di rispondere ad alcun colloquio cui siano stati invitati.',
      changeSingle: 'Sposta il candidato in un\'altra fase',
      infoSingle: 'Sposta il candidato in un\'altra fase. Questa informazione non è visibile al candidato.',
      changedInfoSingle: stage => `Adesso che hai spostato il candidato alla fase "${stage}", faglielo sapere! \n\n Invia un email o un videomessaggio.`,
    },

    modalInterviewAdd: {
      timedTitle: 'Colloquio a tempo',
      timedDescription: 'I candidati registrano le loro risposte alle domande del colloquio in un intervallo di tempo limitato e predefinito. Puoi impostare sia il tempo per la risposta che per la preparazione a ogni domanda.',
      title: 'Crea nuovo colloquio',
      description: 'Scegli il tipo di colloquio da creare',
      friendlyTitle: 'Video colloquio',
      friendlyDescription: 'I candidati possono registrare tutti i filmati che desiderano, senza limiti di tempo per ogni filmato.',
      cancel: 'Annulla',
      continue: 'Continua',
    },

    modalLiveInterviewAdd: {
      title: 'Luo uusi live-haastattelu',
      description: 'Valitse minkä tyyppisen live-haastattelun haluat luoda.',
      basicTitle: 'Normaali live-haastattelu',
      basicDescription: 'Päätät itse haastattelun ajankohdan.',
      scheduledTitle: 'Aikataulutettu live-haastattelu',
      scheduledDescription:
        'Hakija valitsee itselleen sopivan ajan vapaista ajankohdista.',
      cancel: 'Peruuta',
      continue: 'Jatka',
    },

    modalInterviewPublish: {
      modalTitle: 'Impostazioni di pubblicazione',
      publicTitle: 'Colloquio pubblico',
      publicDescription: 'Questo colloquio ha una pagina pubblica con un indirizzo che puoi condividere nei tuoi annunci di lavoro e sulla homepage della tua azienda. Chiunque sia interessato alla posizione può vedere le tue domande e quindi decidere di partecipare. Riceverai la normale notifica quando inizieranno ad arrivare risposte.',
      publishButton: 'Crea link pubblico',
      unPublishButton: 'Rimuovi link pubblico',
      title: 'Colloquio incorporato',
      description: 'I colloqui a domanda singola possono essere perfettamente incorporati nella homepage dell\'azienda. I candidati inseriscono la loro email, registrano una video-risposta e forniscono un link al profilo LinkedIn come informazione aggiuntiva (opzionale).',
      descriptionMultiple:
        'Integra senza problemi un colloquio video nell\'annuncio di lavoro o nella homepage dell\'azienda. I candidati devono solamente inserire il loro indirizzo e-mail e registrare un video con le loro risposte. Inoltre, possono includere un link al loro profilo LinkedIn per ulteriori informazioni.',
      embedNotification: 'Non puoi richiedere altre informazioni con una domanda incorporata.',
      embedButton: 'Crea codice di incorporamento',
      unEmbedButton: 'Rimuovi incorporamento',
      close: 'Chiudi',
      oneError: 'Il colloquio incorporato può avere solo una domanda. Per favore, rimuovi le domande in eccesso per utilizzare la funzione di incorporamento.',
      subscriptionNeeded: 'Hai bisogno di un abbonamento attivo per pubblicare il tuo colloquio.',
    },

    modalIntroduce: {
      title: count => (count > 1 ? 'Presenta candidati' : 'Presenta il candidato'),
      descriptionFirst: 'Con la funzione presentazione puoi presentare dei candidati selezionati a un collega o cliente.',
      descriptionSecond: 'Non è necessario che il destinatario della presentazione effettui la registrazione per poter visualizzare i candidati presentati. Inserisci qui sotto l\'indirizzo e-mail del destinatario. Seleziona quali informazioni vuoi che i destinatari vedano dei candidati. I destinatari vedranno solo le informazioni selezionate. Se selezioni "Valutazione" o "Competenze e compatibilità", i destinatari potranno inserire le loro valutazioni e vedranno anche la valutazione media.',
      descriptionThird: 'È presente anche un\'opzione che permette di proteggere le presentazioni con un codice di accesso che i destinatari dovranno inserire per poter visualizzare i candidati presentati.',
      descriptionFourth: days =>
        `La presentazione scade fra ${days} giorni. Puoi rinviare la scadenza nelle impostazioni delle presentazioni (Modifica presentazioni -> Modifica).`,
      titlePlaceholder: 'Titolo',
      contentPlaceholder: 'Contenuto del messaggio',
      emailsPlaceholder: 'Email dei destinatari',
      namePlaceholder: 'Nome',
      cancel: 'Annulla',
      sendIntroductions: 'Invia presentazioni',
      selectedCandidates: count => `${count} candidati selezionati per essere presentati`,
      successMessage: (candidates, introducees) => `${candidates} candidati presentati a ${introducees} destinatari`,
      infoMessage: (candidates, introducees, isInTeam) => `${candidates} candidati presentati a ${introducees} persone. ${isInTeam} sono gia' nel team di recruitment.`,
      alreadyInTeam: inTeam => (inTeam > 1 ? 'sono gia\' nel team di recruitment.' : 'e\' gia\' nel team di recuitment.'),
      name: 'Nome',
      email: 'Email',
      phone: 'Numero di telefono',
      city: 'Città',
      coverLetter: 'Lettera di presentazione',
      attachments: 'Allegati',
      links: 'Link',
      competencies: 'Competenze e compatibilitá',
      rating: 'Valutazione',
      videoResponses: 'Video risposte',
      comments: 'Commenti',
      informationsHeader: 'Seleziona quali informazioni presentare',
      messageHeader: 'Messaggio di presentazione',
      usePasscodeText: 'Proteggi il gruppo di presentazioni con un codice di accesso',
      passcode: 'Codice di accesso',
      copyToClipboard: 'Copia codice negli appunti',
      generatePasscode: 'Genera nuovo codice di accesso',
      selectAll: 'Seleziona tutto',
      resetSelection: 'Reimposta selezione',
      copySuccess: 'Codice copiato!',
      close: 'Close',
      introduceLinkButton: 'Create link',
      introduceLink: 'Introduce link',
      introduce: 'Introduce',
      formError: 'Error',
      linkCreationError: 'Error creating introduction link',
      link: 'Link',
      continue: 'Continua',
    },

    modalInterviewInvite: {
      senderInfo: "Gli inviti vengono inviati dall'indirizzo email invitations@recright.com.",
      replyToEmail: 'E-mail di risposta per gli inviti ai colloqui',
      replyToName: 'Nome del mittente per gli inviti ai colloqui',
      replyToInfo:
        'Puoi modificare questi campi nella pagina di modifica del colloquio.',
      notAnswerable: 'Non puoi invitare utenti a un colloquio chiuso o a un colloquio che non ha domande a cui è possibile rispondere.',
      title: 'Invita candidati',
      description: 'Inserisci gli indirizzi email di tutti i candidati.',
      description2: 'Quando risponderanno, riceverai una notifica via email. Ricorda che dopo che avrai invitato i candidati non potrai più aggiungere domande.',
      smsDescription: 'Dopo aver spedito gli inviti via e-mail, puoi mandare degli SMS ai candidati',
      addressesPlaceholder: 'Indirizzi email dei candidati',
      submit: 'Invia inviti',
      cancel: 'Annulla',
      close: 'Chiudi',
      templateChangedInfo: 'Hai modificato il messaggio d´invito. Questa modifica verrá inviata a questo elenco di indirizzi, ma non verrá salvata nel video colloquio',
      templateSaved: 'Il messaggio é stato salvato come modello per il video colloquio',
      inviteInfo: (newInvitees, stage) => `Il messaggio di invito verrá inviato a ${newInvitees} candidati tra quelli selezionati. Tutti i candidati selezionati verranno spostati alla fase "${stage}".`,
      invitesSent: (success, failed) => (failed > 0 ? `${success} inviti inviati e ${failed} era già invitato.` : `${success} inviti inviati.`),
      subscriptionNeeded: 'È necessario un abbonamento attivo per invitare i candidati.',
      saveTemplate: 'Salva come messaggio di invito per questo colloquio',
      rrTemplateOptionLabel: 'Modello predefinito di Recright',
      interviewTemplateOptionLabel: 'Messaggio di invito salvato per questo colloquio',
      templateOptionsLabel: 'Seleziona il modello',
    },

    modalInterviewInviteSms: {
      title: 'Inviti spediti',
      description: count => `${count} inviti spediti`,
      description2: 'Vuoi mandare anche degli SMS ai candidati invitati?',
    },

    modalSmsMessage: {
      title: 'Manda SMS',
      invitationTitle: 'Manda SMS d\'invito',
      resendInvitationTitle: 'Manda di nuovo SMS d\'invito',
      description: count => `Il messaggio verrà inviato a ${count} destinatari`,
      missingInvitationDescription: count => `${count} destinatari non hanno ricevuto l'invito. Scrivi il messaggio d'invito qui sotto.`,
      missingPhone: count => `${count} destinatari non hanno un numero di cellulare valido.`,
      missingPhone2: 'Aggiungi i numeri di cellulare nei campi qui sotto.',
      successMessage: count => `${count} SMS mandati.`,
      partialSuccessMessage: (successCount, failedCount) => `${successCount} SMS mandati. Impossibile mandare ${failedCount} SMS.`,
      failedMessage: 'Impossibile mandare gli SMS ai destinatari',
      phonePlaceholder: 'Numero di telefono',
      recipientsNotFound: 'Si è verificato un errore imprevisto. Riprova più tardi. Se il problema persiste, contatta l\'assistenza.',
    },

    modalInterviewStatus: {
      change: 'Modifica stato del colloquio',
      changed: 'Stato del colloquio modificato',
      changedInfo: 'Stato del colloquio modificato. Ricorda di informare i candidati riguardo le decisioni!',
      info: 'Seleziona un nuovo stato per il colloquio.',
      open: 'Aperto',
      closed: 'Chiuso',
      done: 'Fatto',
      close: 'Chiudi',
      endTimeInPast: 'Il colloquio ha una data finale passata. Quando aprirai il colloquio la data finale sarà rimossa. Puoi impostare una nuova data finale dalla ',
      endTimeInPastLink: 'pagina di modifica',
      cancel: 'Annulla',
    },

    modalInterviewSelectForEdit: {
      title: 'Modifica colloquio',
      info: 'Seleziona l´intervista che vuoi modificare.',
      cancel: 'Annulla',
      done: 'Fatto',
      error: {
        selectInterview: 'Seleziona il colloquio.',
      },
    },

    modalInterviewTeaser: {
      title: 'Fai la scelta giusta con i video-colloqui',
      content1: 'Il video-colloquio è la scelta naturale dopo aver ricevuto le candidature dei candidati.',
      upgradeTitle: 'Upgrade 295 EUR/mese',
      upgradeDescription: 'Effettua l\'upgrade del tuo piano per includere 15 posizioni con video-colloqui all\'anno. Il tuo piano attuale sarà sostituito da questo.',
      singleHireTitle: price => `Assunzione Singola ${price} EUR/colloquio`,
      singleHireDescription: 'Utilizza il video-colloquio in una posizione per un periodo di 60 giorni. Puoi invitare molteplici candidati.',
      tryTitle: 'Prova gratuita',
      tryDescription: 'Crea un video-colloquio e registra delle video-domande. Devi effettuare l\'upgrade del tuo piano o acquistare Assunzione Singola prima di poter invitare dei candidati.',
      contactTitle: 'Contattaci',
      contactDescription: 'Inviaci una richiesta di contatto. Ti contatteremo il giorno lavorativo successivo!',
      cancel: 'Annulla',
      confirm: 'Continua',
      greetings: 'Messaggio inviato con successo.',
      confirmTitle: 'Conferma acquisto',
      confirmDescription: 'Manca solo un click per Video-colloquio. Ti basta confermare il pagamento e sei pronto per iniziare!',
    },

    modalJobAdPreview: {
      title: 'Anteprima offerta di lavoro',
      description: 'Qui puoi vedere come l\'offerta di lavoro apparirà al candidato.',
      description2: 'Nota: la lingua dell\'anteprima non è quella impostata per l\'offerta di lavoro.',
      close: 'Chiudi',
      back: 'Indietro',
    },

    modalJobAdStatus: {
      change: 'Modifica stato della posizione lavorativa',
      changed: 'Stato della posizione lavorativa modificato',
      changedInfo: 'Stato della posizione lavorativa modificato. Ricorda di informare i candidati riguardo le decisioni!',
      info: 'Seleziona il nuovo stato per la posizione lavorativa. Impostando lo stato su "Assegnata" o "Annullata" verrai guidato attraverso i passi necessari per selezionare le persone assunte e/o inviare ai rimanenti i messaggi "No, grazie"',
      open: 'Aperto',
      filled: 'Assegnata',
      cancelled: 'Annullata',
      done: 'Fatto',
      close: 'Chiudi',
      draft: 'Chiusa (bozza)',
      closed: 'Chiusa',
      unpublished: 'Non pubblicato',
      hidden: 'Nascosta',
      openDescription: 'Annuncio di lavoro pubblicato fino a',
      filledDescription: 'Chiudi l\'annuncio di lavoro poiché la posizione è stata assegnata.',
      cancelledDescription: 'Chiudi l\'annuncio di lavoro poiché il processo di selezione è stato annullato.',
      closedDescription: 'L\'annuncio di lavoro è chiuso. Non è accessibile o visibile ai candidati.',
      hiddenDescription: 'Nascondi la posizione dalla pagina di selezione. La posizione è visibile solo con un link diretto:',
      unpublishedDescription: 'L\' annuncio di lavoro non e\' stato pubblicato. Non è accessibile o visibile ai candidati.',
      cancel: 'Annulla',
    },

    modalJobPositionTeam: {
      addAnother: 'Aggiungi altri utenti inserendo i loro indirizzi e-mail',
      team: 'Team di selezione',
      info: 'Puoi aggiungere colleghi o altri utenti per esaminare e valutare i candidati',
      newMembersMsg: 'I nuovi membri del team che non dispongono già di un account in Recright verranno aggiunti all\'organizzazione cui appartiene questa posizione.* Se il dominio dell\'indirizzo email dell\'utente non corrisponde a quello collegato all\'organizzazione, le autorizzazioni dell\'utente saranno minime. Le autorizzazioni dell\'utente potranno essere modificate in seguito dagli admin che hanno accesso alla gestione degli utenti.',
      asteriskSymbol: '*',
      currentTeam: 'Team attuale',
      done: 'Fatto',
      remove: 'Rimuovi',
      submit: 'Aggiungi membri al team',
      cancel: 'Annulla',
      selfRemovedMessage: 'Sei uscito dal team di recruitment.',
      successMessage: count => `${count} membri aggiunti al team di reclutamento.`,
      errors: {
        duplicate: 'Questa email è già stata aggiunta.',
        duplicateMultiple: 'Membro/i del team già presente/i con uno o più indirizzi e-mail inseriti.',
        isEmail: 'E-mail non valida.',
        isEmailMultiple: 'Trovate e-mail non valide.',
        isRequired: 'Il campo è obbligatorio.',
      },
    },

    modalJobPositionCopy: {
      title: (context, position) => `Sei sicuro di voler fare una copia ${context === 'jobAd' ? 'della posizione' : 'del colloquio per'} "${position.title}"?`,
      admins: 'Vuoi copiare anche il team di selezione?',
      done: 'Copia',
      cancel: 'Annulla',
    },

    modalVideos: {
      title: 'Libreria video',
      yourVideos: 'I tuoi video',
      companyVideos: 'Video della compagnia',
      sort: {
        createdAt: 'Data di creazione',
        title: 'Titolo',
      },
      add: 'Aggiungi',
      done: 'Aggiungi video',
      cancel: 'Annulla',
    },

    modalUsersAdd: {
      title: 'Invita utenti',
      languageDescription: 'Questi utenti visualizzeranno la seguente lingua:',
      permissionsDescription: 'Questi utenti avranno le seguenti autorizzazioni.',
      emailsPlaceholder: 'Inserisci gli indirizzi email dell\'utente',
      seeAllPositions: 'Vedi tutte le posizioni',
      createJobPositions: 'Crea posizione lavorativa',
      createInterviews: 'Crea colloqui',
      account: 'Modifica dati azienda',
      billing: 'Fatturazione',
      reporting: 'Report',
      editUsers: 'Modifica utenti',
      default: 'Autorizzazioni predefinite azienda',
      cancel: 'Annulla',
      submit: 'Invita utenti',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'Autorizzazioni predefinite azienda:',
      description: 'Tutti i nuovi utenti appartenenti a questa azienda avranno automaticamente le seguenti autorizzazioni predefinite.',
      seeAllPositions: 'Vedi tutte le posizioni',
      createJobPositions: 'Crea posizione lavorativa',
      createInterviews: 'Crea colloqui',
      account: 'Modifica dati azienda',
      billing: 'Fatturazione',
      reporting: 'Report',
      editUsers: 'Modifica utenti',
      cancel: 'Annulla',
      submit: 'Salva',
    },

    modalOtherApplications: {
      title: 'Candidato in altre posizioni',
      header: 'Qui trovi una lista dello stesso candidato in altre posizioni',
      close: 'Chiudi',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: 'Vedi tutte le posizioni',
        createJobPositions: 'Crea posizione lavorativa',
        createInterviews: 'Crea colloqui',
        account: 'Modifica dati azienda',
        billing: 'Fatturazione',
        reporting: 'Report',
        editUsers: 'Modifica utenti',
        default: 'Autorizzazioni predefinite',
      },
    },
    // TODO: Translations missing!
    modalCronofy: {
      linkCalendar: {
        title: 'Link your calendar to Recright',
        description: 'Use our partner Cronofy to link your calendar to Recright',
        authorize: 'Authorize your calendar here',
        authorized: profileName => `You have successfully linked calendar ${profileName} to your Recright account`,
        revokeAuthorization: 'Unlink the calendar from Recright',
      },
      personalInterview: {
        title: 'Create the invitation for scheduled interview',
        description: 'If you’d like to meet the candidate in person, you may invite them to self-schedule a meeting. First, choose the interviewers for the meeting, then set your availability by choosing the dates, times as well as the length of the slots. Add in a message to personalize your invitation. \n\nThe candidate will receive an email to book the meeting. When the candidate chooses a time slot, the interviewers will get an email confirmation with the candidate’s details, and the meeting will appear on the calendar.',
        interviewersHeader: 'Select interviewers',
        noInterviewersSelected: 'Select at least one interviewer with linked calendar to continue',
        otherInterviewersHeader: 'Other interviewers',
        removeOtherInterviewers: 'Remove',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        interviewerCalendarNotConnected:
          "The user's calendar is not connected to Recright, and their availability information cannot be accessed.",
        interviewerCalendarNotConnected2:
          "They'll receive an email with scheduling information and instructions on how to connect their calendar to Recright.",        singleInterviewer: 'Interviewer',
        allInterviewersCalendarNotConnected: 'None of the interviewers have their calendar connected to Recright',
        addMoreInterviewersToTeam: 'Click here to add more interviewers to the team',
        userCalendarNotConnected: 'You don\'t have your calendar connected to Recright',
        userConnectCalendar: 'Connect your calendar here',
        addNewInterviewer: 'Add new interviewer\'s email address',
        timeSlot: {
          description: 'Choose the timeframe and interview length for the interview.\nAfter that you see what slots are available for candidate to choose from.',
          startDate: 'Timeframe start date',
          endDate: 'Timeframe end date',
          endDatePlaceholder: 'End date',
          startDatePlaceholder: 'Start date',
          endDateWarning: 'Select the time frame end date for the scheduled meetings',
          startTime: 'Start time for the day',
          endTime: 'End time for the day',
          timezone: 'Time zone',
          timezoneHelp: 'Please note that changing the timezone also adjusts date and time accordingly.',
        },
        useAllTimeSlots: 'Let candidate choose from all available time slots in the chosen timeframe',
        noTimeSlotsSelected: 'Select at least one timeslot from the Availability below\nor let the candidate choose from all available time slots',
        slotPickerDescription: 'See what slots are available for candidate to choose from.',
        showAvailability: 'Show availability',
        refreshAvailability: 'Refresh availability',
        slotLength: 'Slot length',
        availabilityError: 'Unable to show availability. Please try again later and if the problem persists please contact our support.',
        recipients: count => `Message will be sent to ${count} candidates`,
        confirmRescheduleMessage: 'Cambia data appuntamento',
        confirmRescheduleContent: 'Alcuni destinatari hanno già un appuntamento in programma. Vuoi inviare dei nuovi inviti? Così facendo, sostituirai l\'appuntamento già fissato.',
      },
      personalInterviewMessage: {
        title: 'Create message for calendar invitation',
        successTitle: 'Great',
        successDescription: candidateLength => `You invited ${candidateLength} people to personal interview. They have also been moved to stage 'Personal Interview'`,
        message: {
          emailMessage: 'Email message',
          title: title => `Let’s have a meeting regarding ${title}`,
          content: title => `Hey! We were impressed with your application for ${title} position and would like to invite you for a meeting and tell you a little more about the position and get to know you better.\n\nPlease let me know which of the following times best for you by clicking this scheduling link.\n\nLooking forward to meeting you!`,
          event: {
            header: 'Calendar event information',
            description: 'Insert here information that is included in the calendar event',
            titlePlaceholder: 'Event title',
            locationPlaceholder: 'Event location',
          },
        },
        close: 'Close',
        saveDefaultLocation: 'Save location as default location',
        savedDefaultLocation: 'Saved as default location',
        invitationError: 'We were unable to send calendar invitation. Please try again later and if the problem persists please contact our support.',
      },
    },

    // TODO: Translations missing!
    modalVideoEdit: {
      save: 'Salva',
      cancel: 'Annulla',
      addTag: 'Aggiungi un etichetta',
      title: 'Modifica video',
      success: 'Le modifiche al video sono state salvate correttamente.',
      error:
        'Non è stato possibile salvare le modifiche. Riprova più tardi e, se il problema persiste, contatta il nostro team di assistenza.',
    },

    noResults: {
      description: 'La tua lista sembra vuota. Se hai attivato dei filtri prova a controllarli.',
    },

    notifications: {
      notifications: 'Notifiche',
    },

    notificationsSubscribeButton: {
      subscribe: 'Iscriviti',
      subscribed: 'Iscrizione effettuata',
      unsubscribe: 'Annulla iscrizione',
    },

    onboardTutorial: {
      ui: {
        back: 'Indietro',
        close: 'Chiudi',
        last: 'Precedente',
        next: 'Successivo',
        skip: 'Disattiva',
      },
      dashboard: [
        {
          title: 'Welcome to Recright!',
          text: 'First thing first. Let\'s connect your calendar, so you can schedule meetings with candidates! <a href="/admin/account">Connect your calendar here!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Benvenuto a Recright!',
          text: 'Ti guideremo all\'utilizzo del servizio attraverso delle guide interattive. Puoi visualizzare il testo di aiuto riguardante ogni funzione cliccando sull\'indicatore. Le guide possono essere rese nuovamente visibili in qualsiasi momento cliccando sul tuo nome e su "Mostra tutorial".',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Crea una nuova posizione lavorativa',
          text: 'Crea e pubblica qui una nuova posizione lavorativa e inizia a ricevere candidature.',
          selector: '.joyride--add-job-ad',
          position: 'bottom-left',
        },
        {
          title: 'Crea un nuovo video-colloquio',
          text: 'Crea qui un nuovo video-colloquio e invita candidati.',
          selector: '.joyride--add-videointerview',
          position: 'bottom-left',
        },
        {
          title: 'Impostazioni',
          text: 'Modifica le impostazioni del tuo account, scegli l\'aspetto della tua pagina di selezione e il suo URL, gestisci la tua libreria video e seleziona la lingua preferita. Puoi attivare questa guida anche cliccando su "Mostra tutorial".',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },
      ],
      accountDetails: [
        {
          title: 'Connect your calendar here!',
          text: 'Come on! Do it! Do it now! What are you waiting for?! Do it now!',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'Aggiungi banner e logo',
          text: 'Puoi aggiungere un banner all\'annuncio di lavoro e renderlo visibile ai tuoi candidati. La dimensione ottimale è 1440 x 320 pixel. Ricorda di aggiungere anche il tuo logo.',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'Titolo, sede, date di pubblicazione',
          text: 'Inserisci il titolo e la sede della posizione lavorativa, imposta la data di pubblicazione e la scadenza. Se il campo "Aperta fino" viene lasciato vuoto, la posizione rimarrà aperta a tempo indeterminato.',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: 'Descrizione della posizione',
          text: 'Inserisci o incolla la descrizione della posizione qui. Ricorda di specificare almeno cosa stai cercando, quali sono i requisiti e cosa offri.',
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'Video dell\'azienda',
          text: 'Puoi promuovere la tua cultura aziendale e potenziare l\'employer branding aggiungendo un video dell\'azienda all\'annuncio di lavoro.',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: 'Configurazione del modulo di candidatura',
          text: 'Scegli quali informazioni desideri conoscere riguardo i tuoi candidati. I campi possono essere opzionali o obbligatori.',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: 'Video-domanda',
          text: 'Puoi fare una video-domanda specifica ai tuoi candidati già durante la fase di candidatura e far sì che le candidature prendano vita attraverso le video-risposte. Questa è anche un\'ottima opportunità per presentarti ai tuoi candidati.',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'Aggiungi banner e logo',
          text: 'Puoi aggiungere un banner al colloquio e renderlo visibile ai tuoi candidati. La dimensione ottimale è 1440 x 320 pixel. Ricorda di aggiungere anche il tuo logo.',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'Titolo, aperta fino',
          text: 'Inserisci il titolo del tuo video-colloquio e imposta la data entro la quale si può rispondere. Se lasci vuoto il campo "attiva fino a", il colloquio rimarrà aperto a tempo indeterminato.',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: 'Configurazione modulo per colloquio',
          text: 'Scegli quali informazioni desideri conoscere riguardo i tuoi candidati. I campi possono essere opzionali o obbligatori.',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: 'Domande del colloquio',
          text: 'Registra o carica le tue video-domande. Puoi salvare le video-domande nella libreria dopo averle aggiunte e riutilizzarle in seguito. Puoi anche utilizzare le domande in forma testuale se non hai la possibilità di utilizzare le video-domande. I candidati rispondono sempre con un video.',
          selector: '.joyride--interview-video-questions',
          position: 'top',
        },
      ],
      createdJobAd: [
        {
          title: 'Azioni della posizione lavorativa',
          text: 'Qui puoi modificare la posizione lavorativa, cambiare lo stato e invitare il tuo team a valutare i candidati.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: ' Promozione di una posizione lavorativa',
          text: 'Promuovi il tuo annuncio di lavoro condividendolo sui tuoi canali social.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: 'Azioni del video-colloquio',
          text: 'Qui puoi modificare il videocolloquio, cambiare lo stato e invitare il tuo team a valutare i candidati.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Impostazioni di invito e pubblicazione',
          text: 'Invita i candidati o rendi pubblico il tuo videocolloquio. Poi promuovilo e condividilo sui tuoi canali social.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'Commenti e classificazioni',
          text: 'Puoi commentare i candidati, classificarli con etichette e valutarli con delle stelle. Ricorda di impostare uno stato adeguato al candidato in modo che il tuo team sia a conoscenza della tua decisione. I candidati non possono vedere questa informazione.',
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: 'Profilo della societa\'',
      branding: 'Branding',
      stages: 'Fasi di selezione',
      emailTemplates: 'Modelli di e-mail',
      competencies: 'Competenze',
    },

    passcode: {
      passcode: 'Codice di accesso',
      showPasscode: 'Mostra il codice',
      hidePasscode: 'Nascondi il codice',
    },

    passwordIndicator: {
      errors: [
        'La password deve contenere almeno 12 caratteri.',
        'La password deve essere più breve di 128 caratteri.',
        'La password non può contenere sequenze di 3 o più caratteri ripetuti.',
        'La password deve contenere almeno 1 carattere minuscolo: a-z',
        'La password deve contenere almeno 1 carattere maiuscolo: A-Z',
        'La password deve contenere almeno 1 numero: 0-9',
        'La password deve contenere almeno 1 carattere speciale: (per esempio: !, #, &)',
      ],
      strengthLabel: 'Efficacia password: ',
      strengthValue: {
        insufficient: 'Insufficiente',
        weak: 'Bassa',
        medium: 'Media',
        strong: 'Alta',
      },
      learnMore: 'Impara a creare password efficaci',
    },

    personDetails: {
      namePlaceholder: 'Candidato',
      links: 'Link',
      attachments: 'Allegati',
      coverLetter: 'Lettera di presentazione',
      referrer: 'Origine',
      referrerInfo: 'Il sito web attraverso il quale il candidato è giunto a utilizzare servizio.',
      lastSeen: time => `Visto l'ultima volta ${time}.`,
      headerAdditionalInformation: 'Informazioni aggiuntive',
      state: {
        invited: 'Invitato',
        visited: 'Visto',
        incomplete: 'Non Completato',
        completed: 'Completato',
      },
      notVisited: 'Non ha visualizzato il colloquio',
      otherPersons: count => `Trovato anche in altre ${count} posizioni`,
      name: 'Nome',
      email: 'Email',
      phone: 'Numero di telefono',
      city: 'Città',
    },

    personEdit: {
      header: 'Modifica informazioni del candidato',
      description: context => `Puoi modificare tutte le informazioni di base di un candidato visibili ai candidati nel modulo di ${context === 'application' ? 'candidatura' : 'colloquio'}.`,
      name: 'Nome Candidato',
      email: 'Email Candidato',
      phone: 'Inserisci il tuo numero di telefono',
      city: 'Città Candidato',
      link: 'Aggiungi link, per esempio quello del tuo profilo LinkedIn.',
      links: 'Aggiungi collegamenti per esempio il profilo LinkedIn',
      coverLetter: 'Lettera di presentazione',
      attachments: 'Allegati',
      save: 'Salva',
      cancel: 'Annulla',
      editDetails: 'Modifica informazioni',
      editSuccess: 'Informazioni del candidato salvate!',
    },

    personRow: {
      noStage: 'Ancora in nessuna fase',
      lastSeen: time => `Visto l'ultima volta ${time}.`,
      notVisited: 'Non ha visualizzato il colloquio',
      selectPerson: 'Seleziona',
      deselectPerson: 'Rimuovi Selezione',
      openPersonPage: 'Aperta',
      icons: {
        messages: messagesSent => `${messagesSent} messaggi inviati`,
        message: messagesSent => `${messagesSent} messaggio inviato`,
        noMessages: 'Nessun messaggio inviato',
        introduction: introductions => `${introductions} presentazione`,
        introductions: introductions => `${introductions} presentazioni`,
        noIntroductions: 'Nessuna presentazione',
        comment: comments => `${comments} commento`,
        comments: comments => `${comments} commenti`,
        noComments: 'Nessun commento',
        appliedWithLinkedIn: 'Candidato tramite LinkedIn',
      },
      state: {
        invited: 'Invitato',
        visited: 'Visto',
        incomplete: 'Non Completato',
        completed: 'Completato',
      },
    },

    pipeline: {
      editInterview: 'Modifica colloquio',
      titleLabel: 'Titolo',
      endTimeLabel: 'Data di conclusione',
      statusLabel: 'Stato',
      locationLabel: 'Sede',
      editStages: 'Modifica fase',
      interviewSchedulingDescription: 'This stage contains candidates that have peen invited to a personal meeting.',
      pipelineTooltip: 'Tieni traccia dei canditati lungo il processo di assunzione. Spostali da una fase di reclutamento all\'altro. Puoi filtrare le candidature a seconda delle fasi o altri criteri.',
    },

    positionListing: {
      type: 'Tipo',
      title: 'Titolo',
      owner: 'Proprietario',
      count: 'Conteggio',
      invited: 'Invitato',
      visited: 'Visitato',
      answered: 'Risposto',
      hired: 'Assunto',
      leadTime: 'Lead time',
      leadTimeValue: v => `${v} giorni`,
      created: 'Data di creazione (GMT)',
      start: 'Data di pubblicazione (GMT)',
      end: 'Data di conclusione (GMT)',
      jobAdLabel: 'Offerta di lavoro',
      interviewLabel: 'Videocolloquio',
      timedLabel: 'Colloquio a tempo',
      embedLabel: 'Colloquio incorporato',
      publicLabel: 'Colloquio pubblico',
      timezone: 'Timezone',
      feedback: 'Statistiche sui feedback',
    },

    qrCodeDownload: {
      download: 'Scarico',
    },

    recentPositionsContainer: {
      createNew: 'Crea nuovo',
      showAll: 'Mostra tutto',
    },

    recentJobAds: {
      openJobPositions: 'Posizioni lavorative',
      showAllJobPositions: 'Mostra tutte le posizioni lavorative',
      createNewJobPosition: 'Crea una nuova posizione lavorativa',
      subscriptionNeeded: 'Hai bisogno di un abbonamento attivo per pubblicare questa posizione lavorativa.',
      confirmSingleHire: 'Una delle assunzioni singole che hai acquistato è utilizzata per questa posizione lavorativa.',
      newApplications: 'Candidature da esaminare',
      responses: 'Candidature',
    },

    recentInterviews: {
      openVideoInterviews: 'Video-colloqui',
      showAllVideoInterviews: 'Mostra tutti i video-colloqui',
      createNewVideoInterview: 'Crea un nuovo video-colloquio',
      invites: 'Inviti',
      responses: 'Risposte',
      timedTitle: 'Colloquio a tempo',
    },

    registrationForm: {
      email: 'Email',
      submit: 'Effettua accesso al servizio',
      password: 'Password',
      confirmPassword: 'Confirm password',
      agreeTos: 'Ho letto e approvo i ',
      agreeTosLinkText: 'Termini e condizioni per gli utenti di Recright.',
      privacyPolicy: 'La tua privacy è importante per noi. Leggi la nostra ',
      privacyPolicyLinkText: 'Informativa sulla privacy.',
      licenseAgreement: 'A nome dell\'organizzazione che rappresento, accetto le ',
      licenseAgreementLinkText: 'Condizioni generali di servizio di Recright.',
      newsletter: 'Iscriviti alla newsletter mensile.',
      name: 'Nome',
      namePlaceholder: 'Nome Cognome',
      organization: 'Organizzazione',
      companyDomain: domain => `Permetti agli utenti iscritti con dominio ${domain} di essere aggiunti a questa azienda.`,
      error: {
        password: {
          isRequired: 'È \' richiesta la password ',
          isValidPassword: 'Una password valida deve essere lunga almeno 12 caratteri e deve includere almeno una lettera maiuscola, una minuscola ed un numero.',
          passwordsMatch: 'La password non coincide',
        },
      },
    },

    requestCustomPlan: {
      info: 'Hai volumi di utilizzo maggiori?',
      cta: 'Richiedi un preventivo per un piano personalizzato',
      successMessage: 'Richiesta inviata con successo.',
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission: 'Contatta la persona responsabile della fatturazione nella tua organizzazione.',
    },

    search: {
      placeholder: 'Ricerca',
    },

    searchFilter: {
      filter: 'Filtro',
      headings: {
        location: 'Sede',
        state: 'Situazione',
        status: 'Stato',
        tags: 'Etichette',
        rating: 'Valutazione',
        stage: 'Fase',
      },
      state: {
        invited: 'Invitato',
        visited: 'Visto',
        incomplete: 'Non Completato',
        completed: 'Completato',
      },
      status: {
        open: 'Aperto',
        filled: 'Assegnata',
        cancelled: 'Annullata',
        closed: 'Chiuso',
        draft: 'Chiusa (bozza)',
        unpublished: 'Non pubblicato',
        hidden: 'Nascosta',
        hired: 'Assunto',
        new: 'Nuovo',
        all: 'Tutti',
        proceed: 'Procedi',
        videointerviewed: 'Video-colloquio',
        personalinterview: 'Colloquio personale',
        withdrawn: 'Ritirato',
        scheduledinterview: 'Colloquio programmato',
        rejected: 'Rifiutato',
        finished: 'Terminato',
        coming: 'Prossimo',
        active: 'In corso',
      },
    },

    selectListings: {
      title: 'Annunci',
      description: 'Scegli gli annunci dove la posizione é pubblicata.',
    },

    session: {
      account: 'Gestione dell\'account',
      language: 'Lingua',
      logout: 'Disconnetti',
      whatsNew: 'What\'s New',
      trainingMaterial: 'Formazione Recright',
      expired: 'Per favore, effettua nuovamente l\'accesso.',
      showTutorial: 'Mostra tutorial',
      helpCenter: 'Recright Help Center',
      organization: 'Organizzazione',
    },

    showFeedbackPulse: {
      showPulse: 'Mostra feedback',
      positive: avg => `${avg}% Positivo`,
      feedbackStatistics: 'Statistiche sui feedback',
      noFeedback: 'Ancora nessun feedback',
      responses: responses => `${responses} Risposte`,
    },

    singleHireUseNotification: {
      notificationHeader: count => `Hai ${count} assunzioni singole rimanenti sul tuo account.`,
      notificationBody: "Se inviti candidati o pubblichi il colloquio, verrà utilizzata un'assunzione singola.",
    },

    singleHires: {
      currentCount: count => `${count} assunzioni singole disponibili.`,
      purchase: 'Acquista un\'assunzione singola',
      label: 'Assunzione singola',
      confirmMessage: amount => `Conferma il tuo acquisto di un'assunzione singola. ${amount} EUR verranno addebitati sulla tua carta di credito.`,
    },

    smartrecruitersPublish: {
      title: 'Integrazione con Smartrecruiters',
      description: 'È possibile aggiungere e rimuovere colloqui individuali dall\'elenco dei videocolloqui in Smartrecruiters.',
      notification: 'I colloqui possono impiegare fino a 24 ore prima di apparire in Smartrecruiters.',
      addButton: 'Aggiungi a Smartrecruiters',
      removeButton: 'Rimuovi da Smartrecruiters',
      confirmRemove: 'Vuoi davvero rimuovere il colloquio da Smartrecruiters?',
      addConflict: 'Il colloquio è già stato aggiunto all\'elenco dei Videocolloqui',
      removeConflict: 'Il colloquio è già stato rimosso all\'elenco dei Videocolloqui',
    },

    subscriptionExpired: {
      message: 'Il tuo abbonamento è scaduto',
    },

    subscriptionPlan: {
      plan: 'Piano',
      noActivePlan: 'Non hai un piano attivo.',
      changePlan: 'Modifica piano',
      createSubscription: 'Crea un nuovo abbonamento',
      save: 'Salva',
      cancel: 'Annulla',
      errorFromProcessor: error => `Il gestore del pagamento ha riscontrato l'errore seguente: ${error}`,
    },

    stars: {
      yourRating: rating => `La tua valutazione: ${rating}`,
      totalVotes: count => `${count} valutazioni in tutto`,
      yourRatingReset: 'Reimposta il tuo voto',
    },

    statisticsFilters: {
      timeframe: 'Timeframe',
      owner: 'Owner',
    },

    csStatisticsFilters: {
      timeframe: 'Timeframe',
      autoSuggestCompany: 'Company name',
      companyId: 'Company ID',
      companyDomain: 'Company domain',
      note: 'Note: ',
      noteText:
        'Company name is case sensitive. Company name suggestions are only shown for companies with > 1 jobads or jobopenings.',
    },

    statisticsSummary: {
      jobCountLabel: 'Open job count',
      interviewsLabel: 'Interviews',
      applicationsLabel: 'Applications',
      answersLabel: 'Interview answers',
      activeUsersLabel: 'Active users',
      avgLeadTimeLabel: 'Average lead time',
      avgLeadTimeValue: value => `${value} days`,
    },

    status: {
      opening: {
        open: 'Aperto',
        filled: 'Assegnata',
        cancelled: 'Annullata',
        closed: 'Chiudi',
        draft: 'Chiusa (bozza)',
        hidden: 'Nascosta',
        unpublished: 'Non pubblicato',
      },
      person: {
        hired: 'Assunto',
        proceed: 'Procedi',
        new: 'Nuovo',
        videointerviewed: 'Video-colloquio',
        personalinterview: 'Colloquio personale',
        withdrawn: 'Ritirato',
        scheduledinterview: 'Colloquio programmato',
        rejected: 'Rifiutato',
      },
    },

    transactionList: {
      noTransactions: 'Nessuna transazione',
      createdAt: 'Data',
      type: 'Tipo',
      status: 'Stato',
      amount: 'Somma',
      receipt: 'Ricevuta',
      statuses: {
        authorization_expired: 'Autorizzazione scaduta',
        authorized: 'Autorizzato',
        authorizing: 'Autorizzazione in corso',
        settlement_pending: 'Pagamento in corso',
        settlement_confirmed: 'Pagamento confermato',
        settlement_declined: 'Pagamento rifiutato',
        failed: 'Fallito',
        gateway_rejected: 'Gateway rifiutato',
        processor_declined: 'Processore rifiutato',
        settled: 'Pagato',
        settling: 'Pagamento in corso',
        submitted_for_settlement: 'Inoltrato per pagamento',
        voided: 'Annullato',
      },
      types: {
        sale: 'Vendita',
        credit: 'Credito',
      },
      download: 'Scarico',
      downloadReceipt: 'Scarica la ricevuta',
      notSettled: 'In attesa del pagamento',
    },

    trialBanner: {
      notification: days => `Mancano ${days} giorni al termine del periodo di prova. Se desideri continuare ad utilizzare Recright dovresti acquistare un abbonamento mensile o per un singolo video colloquio.`,
      trialEnded: 'Il periodo di prova é terminato.Se desideri continuare ad utilizzare Recright dovresti acquistare un abbonamento mensile o per un singolo video colloquio.',
      orderHere: 'Abbonati qui!',
    },

    updateCreditCard: {
      save: 'Salva',
      cancel: 'Annulla',
    },

    favorite: {
      popupHeader: 'Seleziona la libreria video',
      yourVideos: 'I tuoi video',
      companyVideos: 'Video della compagnia',
    },

    FavoritesInfo: {
      Favorites: videoLibrary => `Aggiungi i video ai favoriti cliccando l'icona a forma di cuore. Puoi eliminare i video dai favoriti accedendo alla <a href="${videoLibrary}">libreria dei video</a>.`,
    },

    brandingPreview: {
      preview: 'Anteprima',
      header: 'Intestazione di esempio',
      body: lorem => `Questo è un esempio di testo. ${lorem}`,
      linkText: 'Questo è un esempio di link.',
      primaryButtonText: 'Pulsante principale',
      secondaryButtonText: 'Pulsante secondario',
      backButtonText: 'Indietro',
    },

    usersList: {
      generalInformation: 'Informazioni generali',
      latestVisit: date => `Ultima visita ${date}`,
      neverLogger: 'Accesso mai effettuato',
      externalUser: 'Utente esterno',
      inviteExpired: 'Invito scaduto',
      permissions: {
        permissions: 'Autorizzazioni',
        seeAllPositions: 'Vedi tutte le posizioni',
        createJobPositions: 'Crea posizione lavorativa',
        createInterviews: 'Crea colloqui',
        account: 'Modifica dati azienda',
        billing: 'Fatturazione',
        reporting: 'Report',
        editUsers: 'Modifica utenti',
        default: 'Autorizzazioni predefinite',
      },
      actions: {
        actions: 'Azioni',
        activate: 'Attiva',
        deactivate: 'Disattiva',
        removeFromOrganisation: 'Rimuovi dall\'organizzazione',
        hiddenPositions: 'Posizioni nascoste',
      },
      noUsers: 'Nessun utente. Se l\'elenco è filtrato, ridurre il numero di filtri.',
    },

    usersListFilters: {
      sort: {
        name: 'Nome',
        email: 'Email',
        lastAdminAccess: 'Ultimo accesso amministratore',
      },
      find: 'Cerca',
      clearSelections: 'Cancella selezionati',
      usersCount: count => `${count} utenti in totale`,
    },

    usersListActions: {
      editMultipleUsersPermissions: 'Modifica autorizzazioni di più utenti',
      deactivateSelectedUsers: 'Disattiva gli utenti selezionati',
      activateSelectedUsers: 'Attiva gli utenti selezionati',
      addNewUsers: 'Invita utenti',
      save: 'Salva',
      cancel: 'Annulla',
      editUsersPermissions: 'Modifica autorizzazioni utenti',
    },

    linkedInInformation: {
      title: 'Informazioni su LinkedIn:',
      since: 'A partire da',
      summary: 'Riepilogo:',
      fullLinkedInProfile: 'Profilo LinkedIn completo',
    },

    colorPicker: {
      reset: 'Reset',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-mail respinta. Assicurati che il destinatario abbia ricevuto il tuo messaggio.',
      },
      Permanent: {
        General: 'Impossibile consegnare l\'e-mail. Il provider e-mail del destinatario ha respinto il messaggio.',
        NoEmail: 'L\'indirizzo e-mail non esiste.',
        Suppressed: 'L\'e-mail non è stata consegnata a causa di precedenti tentativi di consegna falliti.',
      },
      Transient: {
        General: 'E-mail respinta. Assicurati che il destinatario abbia ricevuto il tuo messaggio.',
        MailboxFull: 'La casella di posta del destinatario è piena.',
        MessageTooLarge: 'Il contenuto del messaggio è troppo grande.',
        ContentRejected: 'Il contenuto del messaggio è stato respinto.',
        AttachmentRejected: 'L\'allegato è stato respinto.',
      },
    },

    videoBackgroundUpload: {
      header: "Immagine di sfondo del video dell'organizzazione",
      description:
        'Immagine che gli utenti della tua organizzazione possono utilizzare come immagine di sfondo per i video che registrano.',
      add: 'Aggiungi immagine di sfondo del video',
      info: "Le dimensioni consigliate per l'immagine sono 720x480 pixel.",
    },
  },

  page: {
    account: {
      title: 'Gestione dell\'account',
      details: 'Dettagli dell\'account',
      name: 'Nome dell\'account',
      save: 'Salva',
      saved: 'Informazione dell\'account salvate.',
      signature: 'Firma',
      permissions: 'Autorizzazioni',
      calendar: {
        label: 'Calendar',
        notAuthorized: 'Authorize your calendar here',
        authorized: 'Edit your calendar authorization',
        revokeError: 'We were unable to unlink your calendar. Please try again later and if the problem persists please contact our support.',
        revokeSuccess: 'Successfully unlinked your calendar',
      },
      password: 'Password',
      statistics: 'Statistics',
      organization: 'Organizzazione',
    },

    actionBar: {
      selection: 'selezionati',
    },

    organisationProfile: {
      title: 'Profilo della societa\'',
      details: 'Configurazione del profilo della societa\'',
      brandingHeader: 'Branding dell\'organizzazione',
      name: 'Nome della societa\'',
      owner: 'Proprietario dell\'account',
      customReplyToSubtitle:
        "Qui puoi modificare il nome del mittente e l'indirizzo di risposta per gli inviti ai colloqui. Se lasci il campo vuoto, vengono utilizzati il nome e l'e-mail dell'utente che invia gli inviti.",
      customReplyToEmail: 'E-mail di risposta per gli inviti ai colloqui',
      customReplyToName: 'Nome del mittente per gli inviti ai colloqui',
      senderInfoDisabled:
        "L'aggiornamento delle informazioni sul mittente dell'invito al colloquio è disabilitato perché i colloqui video sono disabilitati per la tua organizzazione.",
      slug: 'URL del sito di selezione',
      slugUnavailable: 'Questo URL è già riservato.',
      slogan: 'Slogan del sito di annunci',
      language: 'Lingua del sito di selezione',
      languagePlaceholder: 'Scegli',
      rss: 'Flusso RSS del sito di selezione',
      type: 'Tipo di account',
      types: {
        free: {
          title: 'Gratuito',
          description: 'Servizi inclusi nell\'account gratuito\n1 utente\n1 posizione lavorativa aperta alla volta',
        },
        basic: {
          title: 'Base',
          description: 'Servizi inclusi nell\'account base\nPosizioni lavorative aperte illimitate\nVideo-colloqui',
        },
        team: {
          title: 'Team',
          description: 'Servizi inclusi nell\'account Team\nPosizioni lavorative aperte illimitate\nVideo-colloqui\nPresentazioni dei candidati',
        },
      },
      save: 'Salva',
      reset: 'Reset',
      companyAdminUsers: 'Company admin users',
      saved: 'Informazioni della societa\' salvate.',
      cancel: 'Annulla',
      confirmLeave: 'Ci sono delle modifiche non salvate. Sei sicuro di voler uscire?',
      error: {
        required: 'Gli elementi contrassegnati con un * asterisco sono obbligatori.',
      },
      emailBrandingHeader: 'Branding delle email',
      emailBrandingDescription:
        'Personalizza i colori delle e-mail inviate ai candidati.',
    },

    organisationCompetencies: {
      title: 'Competenze dell\'organizzazione',
      description: 'Qui puoi modificare, aggiungere ed eliminare le competenze dell\'organizzazione. Queste saranno le competenze predefinite per le nuove posizioni create da questa compagnia e si trovano per i candidati a quelle posizioni nella sezione "Competenze e compatibilità".',
    },

    organisationStages: {
      title: 'Fasi di selezione dell\'organizzazione',
      description: 'Qui puoi modificare, aggiungere, eliminare e riordinare le fasi della selezione. Queste saranno le fasi di reclutamento predefinite per le nuove posizioni create dall\'azienda.',
    },

    organisationEmailTemplates: {
      preview:
        "Visualizza l'anteprima dell'e-mail (l'anteprima non include tutta la formattazione dell'e-mail finale)",
      preview2:
        "I colori dei modelli di e-mail possono essere personalizzati nella pagina delle impostazioni di branding dell'organizzazione.",
      timedInterviewPreviewInfo:
        "Il messaggio per il colloquio a tempo non contiene la parte relativa al contatto dell'assistenza.",
      templateTypes: {
        interviewInvite: 'Invito al colloquio video',
        timedInterviewInvite: 'Invito al colloquio a tempo',
        interviewCompleted:
          'Messaggio di completamento colloquio / ringraziamento per i candidati',
        applicationCompleted: "Candidatura per l'annuncio di lavoro completata",
      },
      subHeaders: {
        jobAdLabel: 'Offerta di lavoro',
        interviewLabel: 'Videocolloquio',
      },
      deleteTemplate: 'Elimina modello',
      confirmation: templateName =>  `Vuoi davvero eliminare il modello "${templateName}" dai modelli di e-mail dell'organizzazione?`,
      deleteSuccess:
        "Il modello è stato eliminato dai modelli di e-mail dell'organizzazione",
      emailTemplateInfo: 'Attualmente è possibile salvare un solo modello con una sola lingua.',
      templateError: 'Template with same name or language already exists.',
    },

    application: {
      back: 'Ritorna all\'elenco delle candidature.',
      delete: 'Elimina candidatura',
      deleted: 'Candidatura eliminata',
      interviewClosed: 'Il colloquio é chiuso',
      resendInvitation: 'Invia nuovamente invito al candidato',
      changeStage: 'Muovi ad un altra fase',
      commentsAndClassifications: 'Commenti e classificazioni',
      openingTitle: title => `Video-colloquio - ${title}`,
      yourRatingText: 'La tua valutazione:',
      competencesAndCompatibility: 'Competenze e compatibilitá',
      duplicateCompetency: 'La competenza esiste già',
      competencyNotFound: 'Competenza non trovata o eliminata',
      confirmDelete: 'Vuoi davvero cancellare questa candidatura?',
      lastSeen: time => `Visto l'ultima volta ${time}.`,
      stageChangedInfo: stage => `Ora che hai spostato questi candidati alla fase "${stage}" faglielo sapere! Manda loro una mail o un video messaggio.`,
      stageChanged: 'Bene!',
      close: 'Chiudi',
      reopenProcessConfirm: 'Vuoi davvero spostare questo candidato dalla fase "Ritirato" e reinserirlo nel processo di reclutamento? Dopo la conferma, il candidato sarà di nuovo in grado di rispondere a qualsiasi colloquio che non ha già completato.',
      withdrawConfirm: 'Vuoi davvero ritirare questo candidato dal processo di reclutamento? Se ritirato, il candidato non sarà più in grado di rispondere ad alcun colloquio cui sia stato invitato.',
      changestageTooltip: 'Puoi visualizzare la fase in cui si trova attualmente il candidato, e modificarla manualmente cliccando sulla fase desiderata. Il candidato riceverà una notifica.',
      commentsTooltip: 'Puoi lasciare ai tuoi colleghi un commento sulla candidatura. Il candidato non ha accesso a queste informazioni.',
      competencesTooltip: 'Puoi aggiungere o valutare una competenza. I tuoi colleghi potranno vedere e valutare le competenze che inserisci, nonché aggiungerne altre. Il candidato non ha accesso a queste informazioni.',
      actionlogTooltip: 'Qui appariranno i commenti, i cambiamenti di fase, i messaggi e altre attività. Il candidato non può vedere queste informazioni.',
      stage: {
        new: 'Nuovo',
        hired: 'Assunto',
        proceed: 'Procedi',
        personalinterview: 'Colloquio personale',
        withdrawn: 'Ritirato',
        scheduledinterview: 'Colloquio programmato',
        rejected: 'Rifiutato',
        videointerviewed: 'Video-colloquio',
      },
      state: {
        invited: 'Invitato',
        visited: 'Visto',
        incomplete: 'Non Completato',
        completed: 'Completato',
      },
      notVisited: 'Non ha visualizzato il colloquio',
    },

    billing: {
      title: 'Fatturazione',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) => `La prossima fatturazione sarà di ${nextBillingPeriodAmount} EUR il ${nextBillingDate}`,
      status: 'Stato',
      singleHire: 'Assunzione singola',
      billingOverview: 'Panoramica della fatturazione',
      payment: 'Pagamento',
      paymentHistory: 'Cronologia pagamenti',
      updateDetails: 'Aggiorna informazioni di fatturazione',
      billingStatus: {
        pending: 'In sospeso',
        active: 'Attivo',
        pastdue: 'In ritardo',
        expired: 'Scaduto',
        canceled: 'Annullata',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: 'Registro delle azioni',
      back: 'Torna alla lista dei candidati',
      delete: 'Elimina candidato',
      deleted: 'Candidato eliminato',
      interviewClosed: 'Il colloquio é chiuso. Non è stato inviato nuovamente alcun invito.',
      resendInvitation: 'Invia nuovamente invito al candidato',
      changeStage: 'Muovi ad un altra fase',
      introducedTo: 'Presentato a:',
      yourRatingText: 'La tua valutazione:',
      competencesAndCompatibility: 'Competenze e compatibilitá',
      duplicateCompetency: 'La competenza esiste già',
      competencyNotFound: 'Competenza non trovata o eliminata',
      confirmDelete: 'Vuoi davvero cancellare questo candidato?',
      stageChangedInfo: stage => `Ora che hai spostato questi candidati alla fase "${stage}" faglielo sapere! Manda loro una mail o un video messaggio.`,
      stageChanged: 'Bene!',
      close: 'Chiudi',
      hideStages: 'Nascondi fasi',
      showStages: 'Mostra fasi',
      resetQuestionResponseSuccess: 'La risposta del candidato è stata cancellata',
      stage: {
        new: 'Nuovo',
        hired: 'Assunto',
        proceed: 'Procedi',
        personalinterview: 'Colloquio personale',
        withdrawn: 'Ritirato',
        scheduledinterview: 'Colloquio programmato',
        rejected: 'Rifiutato',
        videointerviewed: 'Video-colloquio',
      },
    },

    dashboard: {
      upcomingLiveInterviews: 'Colloqui in diretta',
      showAllLiveInterviews: 'Mostra tutti i colloqui in diretta',
      createNewLiveInterview: 'Crea nuovo colloquio in diretta',
      welcome: name => `Benvenuto, ${name}!`,
      liveCard: {
        startTime: 'Orario d\'inizio',
        interviewers: 'Intervistatori',
        candidates: 'Candidati',
      },
    },

    interviewEdit: {
      title: 'Titolo del colloquio',
      titleLabel: 'Titolo del colloquio',
      location: 'Sede',
      publishTimePlaceholder: 'Data di pubblicazione',
      publishTimeTooltip: 'Imposta una data di pubblicazione del colloquio. Potrai modificarla in qualsiasi momento.',
      endTime: 'attiva fino a',
      endTimeTooltip: 'Seleziona la scadenza del periodo di candidatura.',
      timezone: 'Fuso orario',
      isNotPastDate: 'la data è passata.',
      interviewIsClosed: 'Il colloquio è al momento chiuso. Desideri ',
      interviewIsClosedLink: 'aprirlo?',
      edit: {
        details: 'Modifica colloquio',
        status: 'Modifica stato del colloquio',
        team: 'Modifica team',
      },
      questions: 'Domande del colloquio',
      answerable: 'Alla domanda può essere data una risposta',
      questionsDescription: 'Queste sono le domande a cui i candidati devono rispondere.',
      questionsNotEditable: 'Le domande non possono essere modificate una volta che gli inviti sono stati inviati.',
      saved: 'Colloquio salvato',
      deleted: 'Colloquio eliminato',
      delete: 'Elimina colloquio',
      cancel: 'Annulla',
      save: 'Salva',
      language: 'Lingua del colloquio',
      languagePlaceholder: 'Scegli',
      languages: {
        en: 'Italiano',
        fi: 'Finlandese',
      },
      confirmLeave: 'Ci sono delle modifiche non salvate. Sei sicuro di voler uscire?',
      OnboardingHeadImageSize: 'La dimensione dell´immagine della testata é di 1440px*320px o maggiore.',
      takeLimitLabel: 'Quantità di filmati',
      answerTimeLabel: 'Tempo di risposta',
      preparationTimeLabel: 'Tempo di preparazione',
      confirmHeader: 'Vuoi davvero eliminare questo colloquio?',
      integratedConfirmContent: 'Questo colloquio è integrato con un altro sistema e rimuoverlo potrebbe causare problemi all\'integrazione.',
    },

    interview: {
      endTime: date => (date ? `, attiva fino a ${date}` : ''),
      edit: 'Modifica colloquio',
      copy: 'Copia colloquio',
      editInvitation: 'Modifica il messaggio d´invito',
      editTeam: 'Modifica team',
      editMenu: 'Modifica',
      questions: 'Domande del colloquio',
      changeStatus: 'Modifica stato del colloquio',
      publishSettings: 'Impostazioni di pubblicazione',
      invite: 'Invita candidati',
      showCandidates: 'Mostra candidati',
      oneError: 'I colloqui incorporati possono includere solo una domanda.',
      copySuccess: 'Il colloquio è stato copiato',
      editIntroduceBatches: 'Modifica presentazioni',
      editEmailSettings: 'Modifica impostazioni e-mail',
    },

    interviews: {
      allInterviews: 'Tutti i video-colloqui',
      createNewVideoInterview: 'Crea un nuovo video-colloquio',
      filter: 'Ricerca colloqui',
      invites: 'Inviti',
      responses: 'Risposte',
      sort: {
        title: 'Titolo',
        status: 'Stato',
        publishTime: 'Data di pubblicazione',
        endTime: 'Data di conclusione',
        createdAt: 'Data di creazione',
        updatedAt: 'Ultima Modifica',
        answeredCount: 'Candidati',
      },
    },

    interviewCandidates: {
      preview: 'Anteprima',
      endTime: date => (date ? `attiva fino a ${date}` : ''),
      publicTitle: 'Colloquio pubblico',
      embedTitle: 'Colloquio incorporato',
      placeholder: {
        first: 'Non c\'è ancora nessun candidato.',
        second: 'Puoi anche rendere il tuo video-colloquio pubblico.',
        third: 'In questo modo, chiunque sia interessato alla posizione potrà vedere il colloquio e candidarsi.',
        fourth: 'Non dimenticare che per tutte queste azioni è presente un pulsante sulla barra del titolo in alto.',
      },
      title: 'Tutti i candidati',
      sort: {
        default: 'Predefinito',
        updatedAt: 'Ultima Modifica',
        name: 'Nome',
        rating: 'Valutazione',
        createdAt: 'Data di creazione',
      },
      sendMessage: 'Invia messaggio',
      changeStage: 'Muovi ad un altra fase',
      introduce: 'Presenta',
      filter: 'Ricerca candidati',
      hideFilters: 'Nascondi i filtri',
      showFilters: 'Mostra i filtri',
      emailSent: 'Email inviata!',
      interviewClosedError: 'Non puoi invitare nuovamente un candidato ad un video colloquio chiuso.',
      excel: 'Esporta tutti i candidati',
      reInviteSent: candidates => `${candidates} inviti rispediti!`,
    },

    jobAdEdit: {
      preview: 'Anteprima',
      confirm: 'Sei sicuro di voler aggiungere questa posizione?',
      deleteHeader: 'Sei sicuro di voler eliminare questa posizione?',
      deleteContent: 'L\'eliminazione di questo lavoro cancella anche tutte le informazioni relative al posto di lavoro, quali le domande e i video dei colloqui.',
      titlePlaceholder: 'Titolo della Posizione',
      timezone: 'Fuso orario',
      locationPlaceholder: 'Sede',
      endTimePlaceholder: 'attiva fino a ',
      endTimeTooltip: 'Seleziona la scadenza del periodo di candidatura.',
      isNotPastDate: 'la data è passata.',
      publishTimePlaceholder: 'Data di pubblicazione',
      publishTimeTooltip: 'Imposta una data di pubblicazione per l\'annuncio di lavoro. Puoi cambiare la data quando vuoi.',
      language: 'Lingua',
      languagePlaceholder: 'Scegli',
      languages: {
        en: 'Italiano',
        fi: 'Finlandese',
      },
      description: 'Descrizione della posizione',
      saved: 'Lavoro salvato',
      deleted: 'Lavoro eliminato',
      descriptionPlaceholder: 'Scrivi la tua descrizione qui. \n\nPuoi arricchire la descrizione con gli strumenti di modifica del testo presenti in alto.',
      createInviteOnly: 'Crea un video-colloquio solo su invito',
      delete: 'Elimina posizione',
      cancel: 'Annulla',
      save: 'Salva',
      confirmLeave: 'Ci sono delle modifiche non salvate. Sei sicuro di voler uscire?',
      singleHireEndError: 'L\'assunzione singola non può essere utilizzata per più di 60 giorni.',
      OnboardingHeadImageSize: 'La dimensione dell´immagine della testata é di 1440px*320px o maggiore.',
    },

    jobAdApplications: {
      endTime: date => (date ? `, attiva fino a ${date}` : ''),
      title: 'Tutte le candidature',
      sort: {
        updatedAt: 'Ultima Modifica',
        name: 'Nome',
        rating: 'Valutazione',
        createdAt: 'Data di creazione',
      },
      add: 'Aggiungi nuovo candidato',
      inviteToInterview: 'Invita al colloquio',
      sendMessage: 'Invia messaggio',
      changeStage: 'Muovi ad un altra fase',
      introduce: 'Presenta',
      editIntroduceBatches: 'Modifica presentazioni',
      filter: 'Ricerca candidature',
      hideFilters: 'Nascondi i filtri',
      showFilters: 'Mostra i filtri',
      addInterviewConfirm: jobAd => `Vuoi creare un video colloquio legato alla posizione "${jobAd}"?`,
    },

    adminJobAdApplication: {
      name: 'Nome',
      email: 'Email',
      phone: 'Numero di telefono',
      city: 'Città',
      back: 'Indietro',
      continue: 'Continua',
      submit: 'Aggiungi',
      namePlaceholder: 'Nome Candidato',
      emailPlaceholder: 'Email Candidato',
      cityPlaceholder: 'Città Candidato',
      links: 'Aggiungi collegamenti per esempio il profilo LinkedIn',
      legendAdditionalFields: 'Informazioni aggiuntive',
      legendBasicInfo: 'Informazioni di base',
      legendLinks: 'Link',
      legendAttachments: 'Allegati',
      coverLetter: 'Lettera di presentazione',
      attachments: 'Allegati',
      introduction: 'Scrivi qui una breve presentazione',
      readyInfo: 'Grazie. Il candidato è stato aggiunto alla posizione lavorativa.',
      close: 'Chiudi',
      required: 'Gli elementi contrassegnati con un * asterisco sono obbligatori.',
      excel: 'Esporta tutte le candidature',
    },

    jobAdPreview: {
      endTime: date => (date ? `, attiva fino a ${date}` : ''),
      exit: 'Esci dall\'anteprima',
      description: 'Descrizione della posizione',
      video: 'Video dell\'azienda',
      questions: 'Video-domanda',
      apply: 'Candidati per la posizione',
    },

    jobAd: {
      endTime: date => (date ? `, attiva fino a ${date}` : ''),
      changeStatus: 'Modifica stato della posizione lavorativa',
      edit: 'Modifica posizione',
      copy: 'Copia la posizione',
      editInvitation: 'Modifica il messaggio d´invito',
      editTeam: 'Modifica team',
      editMenu: 'Modifica',
      description: 'Descrizione della posizione',
      video: 'Video dell\'azienda',
      questions: 'Video-domanda',
      apply: 'Candidati per la posizione',
      showApplications: 'Mostra candidature',
      publicLink: 'Pagina pubblica dell\'annuncio di lavoro',
      copySuccess: 'La posizione è stata copiata',
    },

    jobAds: {
      subscriptionNeeded: 'Hai bisogno di un abbonamento attivo per pubblicare questa posizione lavorativa.',
      responses: 'Candidature',
      createNewJobPosition: 'Crea una nuova posizione lavorativa',
      allJobPositions: 'Tutte le posizioni lavorative',
      confirmSingleHire: 'Una delle assunzioni singole che hai acquistato è utilizzata per questa posizione lavorativa.',
      filter: 'Ricerca posizioni lavorative',
      sort: {
        title: 'Titolo',
        publishTime: 'Data di pubblicazione',
        applicationCount: 'Candidature',
        endTime: 'Data di conclusione',
        createdAt: 'Data di creazione',
        updatedAt: 'Ultima Modifica',
      },
    },

    jobAdSaved: {
      title: 'Posizione lavorativa salvata!',
      description: 'Il tuo annuncio di lavoro è ora salvato. Il seguente è un link pubblico all\'annuncio:',
      addApplication: 'Link diretto al modulo di candidatura:',
      toDashboard: 'Prima pagina',
      toJobAd: 'Torna all\'annuncio di lavoro',
    },

    live: {
      title: 'Colloquio in diretta',
      editTitle: 'Modifica colloquio in diretta',
      startTimeTitle: 'Orario di inizio del colloquio',
      startTime: 'Orario d\'inizio',
      interviewers: 'Intervistatori',
      candidates: 'Candidati',
      messageLabel: 'Testo dell’invito',
      create: 'Crea',
      save: 'Salva modifiche',
      cancel: 'Annulla',
      removeLive: 'Rimuovi colloquio in diretta',
      cancelLive: 'Annulla colloquio in diretta',
      comment: 'Aggiungi un nuovo commento',
      commentLabel: 'Commenti',
      enter: 'Accedi al colloquio in diretta',
      edit: 'Aggiungi/rimuovi partecipanti',
      draft: 'Nuovo colloquio in diretta',
      pending: 'Waiting for candidate confirmation',
      scheduledLiveCandidateSubtitle:
        'For the scheduled live interview you can only add one candidate.',
      confirmHeader: 'Vuoi davvero eliminare questo colloquio?',
      inviteFailure: (success, failed) => `${success} inviti inviati e ${failed} non riusciti!`,
      inviteSuccess: success => `${success} inviti inviati.`,
      recordingsHeaderWithTitle: title =>
        `Registrazioni per colloqui in diretta ${title}`,
      recordingsHeader: 'Registrazioni colloqui in diretta',
      success: {
        create: 'Nuovo colloquio in diretta creato',
        delete: 'Colloquio in diretta rimosso',
        update: 'Colloquio in diretta aggiornato',
      },
      placeholders: {
        candidateEmails: 'Aggiungi candidato',
        interviewerEmails: 'Aggiungi intervistatore',
        emailTitle: 'Titolo',
        emailMessage: 'Messaggio',
        emailName: 'Nome',
      },
    },

    lives: {
      allLives: 'Tutti i colloqui in diretta',
      createNewLive: 'Crea nuovo colloquio in diretta',
      filter: 'Ricerca per candidato',
      candidates: 'Candidati',
      sort: {
        title: 'Titolo',
        startTime: 'Orario d\'inizio',
        createdAt: 'Data di creazione',
      },
    },

    login: {
      title: 'Effettua accesso al servizio',
      register: 'Registrati',
      ldap: 'Accedi con integrazione LDAP',
      forgot: 'Hai dimenticato la password?',
      normal: 'Accesso normale',
      ssoLogin: 'Accesso SSO',
    },

    publicSubscribe: {
      intro: 'Scegli il piano adatto a te, inserisci i tuoi dati di pagamento e utilizza lo strumento di selezione immediatamente. Tutti i tuoi pagamenti vengono processati in maniera sicura dal nostro sistema di pagamenti Braintree.',
      headline: 'Modulo di abbonamento',
      header: {
        back: 'Back',
      },
      footer: {
        product: 'Product',
        pricing: 'Pricing',
        resources: 'Resources',
        contact: 'Contact',
        terms: 'User Terms and Conditions',
        privacyPolicy: 'Privacy policy',
        license: 'General Terms of Service',
      },
    },

    publicSubscribeThankYou: {
      title: 'Grazie!',
      existingDescription: 'Abbiamo ricevuto le informazioni riguardanti il tuo abbonamento e puoi continuare a utilizzare lo strumento di selezione video.',
      newUserDescription: 'Abbiamo creato il tuo account e ti abbiamo inviato via email le informazioni su come impostare la tua password.',
    },

    quickInterview: {
      title: 'Video-colloquio veloce',
      description: 'Per conoscerci più rapidamente desidereremmo che tu rispondessi brevemente alle nostre veloci domande del colloquio. Mettici la tua personalità e dai un\'anima alla tua candidatura.',
      requiredNote: 'Ricorda che questo fa parte del processo di candidatura, e che il recruiter riceverà la tua candidatura solo dopo che avrai registrato la tua risposta.',
      reminderNote: 'Puoi registrare subito la tua risposta, oppure puoi continuare più tardi ricevendo un promemoria sulla tua email.',
    },

    register: {
      title: 'Progettato per i reclutatori!',
      leadText: 'Recright è una piattaforma di video-reclutamento semplice da usare per reclutatori e responsabili delle risorse umane. È possibile pubblicare posizioni aperte, ricevere candidature e svolgere videocolloqui, tutto in un unico posto! Il nostro strumento ha aiutato più di 400 aziende a trovare le persone giuste e la tua potrebbe essere la prossima! Iscriviti qui sotto e inizia a reclutare!',
      email: 'Email',
      submit: 'Registra',
      alreadyMember: 'Sei già iscritto?',
      onlyForRecruiters: 'Questa iscrizione è solo per reclutatori e responsabili delle risorse umane.',
      login: 'Accedi qui.',
      registerSuccess: 'Grazie, abbiamo inviato alla tua casella di posta un invito per la registrazione.',
      domainError: 'Registrati con il tuo indirizzo e-mail aziendale.',
      companyExistsMessage: 'Controlla la tua email per le istruzioni!',
    },

    searchResults: {
      title: 'Risultati della ricerca',
      applications: 'Candidature',
      candidates: 'Candidati',
      noApplications: 'Nessuna candidatura corrispondente ai criteri di ricerca',
      noCandidates: 'Nessun candidato corrispondente ai criteri di ricerca',
      query: query => (query ? `Search query: ${query}` : ''),
      noStage: 'Ancora in nessuna fase',
      search: 'Cerca',
      itemsPerPage: 'Items per page',
    },

    statistics: {
      linkToDetailed: 'See detailed statistics',
      linkToSummary: 'See statistics summary',
      summaryLeadText: 'Figures below comprises of all active positions during the selected time period including the positions that do not have an end date.',
      detailsLeadText: 'This page provides detailed statistics on all positions with any activity during the selected time period.',
      export: 'Export statistics',
      sort: {
        title: 'Titolo',
        owner: 'Owner',
        createdAt: 'Data di creazione',
      },
      exportLimit:
        'Too many results. Please reduce the timeframe to enable excel export.',
      tooManyResults:
        'Too many results. Please reduce the timeframe to get results.',
    },

    welcome: {
      title: 'Iscriviti',
    },

    welcomeMulticompany: {
      welcome: companyName => `Ti diamo il benvenuto in ${companyName}`,
      successMessage: companyName =>
        `Ora fai parte dell'organizzazione ${companyName}!`,
      navigationInfo:
        'Puoi modificare l\'organizzazione attuale dalla barra di navigazione in alto a destra.',
      login: 'Accedi qui',
    },

    forgotPassword: {
      title: 'Scegliere una nuova password',
      email: 'Email',
      submit: 'Invia',
      sendEmail: 'Inviaci l\'indirizzo email con il quale ti sei registrato a Recright.',
      instructions: 'Ti invieremo istruzioni su come modificare la tua passsword.',
      success: 'Se è stato trovato un utente con la mail che hai fornito, le istruzioni per cambiare la tua password sono state inviate a quella mail.',
    },

    changePassword: {
      title: 'Scelta della tua password',
      name: 'Nome',
      email: 'Email',
      password: 'Nuova password',
      confirmPassword: 'Ripetere la nuova password',
      submit: 'Cambio della password',
      error: {
        password: {
          isRequired: 'È \' richiesta la password ',
          isValidPassword: 'Una password valida deve essere lunga almeno 12 caratteri e deve includere almeno una lettera maiuscola, una minuscola ed un numero.',
          passwordsMatch: 'La password non coincide',
        },
      },
    },

    ssoLogin: {
      title: 'Accesso SSO',
      description: 'Accedi utilizzando le credenziali della tua organizzazione.',
      info: 'L’autenticazione esterna non è stata configurata. Utilizza il',
      normalLoginLinkText: 'metodo d’accesso normale.',
      submit: 'Effettua accesso al servizio',
    },

    subscribe: {
      title: 'Abbonati',
      submit: 'Abbonati',
      creditCard: 'Carta di credito',
      cvv: 'CVV',
      expirationDate: 'Data di scadenza',
      vatAdvice: 'Fornendo il numero di PIVA, non verrà comunque applicata IVA al vostro ordine.',
      vatId: 'Partita IVA / Codice fiscale',
      vatHelp: 'Fornisci il tuo numero di partita IVA nel formato internazionale includendo il codice del paese.',
      includeVat: 'IVA incl.',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      company: 'Azienda',
      street: 'Via',
      postalCode: 'Codice postale',
      city: 'Città',
      country: 'Paese',
      emptyCardFields: 'Per favore, inserisci i dati della tua carta di credito',
      invalidValue: 'Il valore inserito nel campo non è valido.',
      planNotSelected: 'Seleziona piano',
      totalPrice: 'Totale',
      subscribed: 'Fantastico! Il tuo abbonamento è stato creato.',
      subscriptionExists: 'Sembra che la tua azienda abbia un abbonamento attivo. Effettua l\'accesso per modificare il tuo abbonamento.',
      agreeTos: 'Ho letto e approvo i ',
      agreeTosLinkText: 'Termini e condizioni per gli utenti di Recright.',
      privacyPolicy: 'Ho letto e compreso la.',
      privacyPolicyLinkText: 'Informativa sulla privacy.',
      licenseAgreement: 'A nome dell\'organizzazione che rappresento, accetto le ',
      licenseAgreementLinkText: 'Condizioni generali di servizio di Recright.',
      newsletter: 'Iscriviti alla newsletter mensile.',
      neverExpiresDiscount: amount => `Sconto a vita incluso ${amount} EUR`,
      fixedPeriodDiscount: (amount, cycles) => `Sconto incluso ${amount} EUR per ${cycles} mesi`,
      errorFromProcessor: error => `Il gestore del pagamento ha riscontrato l'errore seguente: ${error}`,
    },

    videos: {
      title: 'Libreria video',
      add: 'Crea un nuovo video',
      rename: 'Rinomina',
      remove: 'Rimuovi',
      yourVideos: 'I tuoi video',
      companyVideos: 'Video della compagnia',
      sort: {
        createdAt: 'Data di creazione',
        title: 'Titolo',
      },

    },

    userManagement: {
      excel: 'Esporta tutti gli utenti',
      title: 'Gestione utenti',
      showCompanyDefaultPermissions: 'Mostra autorizzazioni predefinite dell\'azienda',
      activateUserConfirm: 'Attivare questo utente?',
      deactivateUserConfirm: 'Disattivare questo utente?',
      showActivatedUsers: 'Mostra utenti attivi',
      showDeactivatedUsers: 'Mostra utenti inattivi',
      confirmCancelEditPermissions: {
        message: 'Le modifiche non sono state salvate. Eliminare le modifiche?',
        cancel: 'Annulla',
        confirm: 'Elimina modifiche',
      },
      unsavedChanges: 'Le modifiche non sono state salvate. Salvare le modifiche?',
      confirm: 'Salva',
      permissionsChangesSaved: 'Autorizzazioni modificate correttamente!',
      userDeactivated: nameOrEmail => `Disattivazione ${nameOrEmail} effettuata`,
      userActivated: nameOrEmail => `Attivazione ${nameOrEmail} effettuata`,
      companyDefaultsSaved: 'Autorizzazioni di amministrazione predefinite modificate!',
      usersAddAdded: success => `${success} utenti aggiunti.`,
      usersAddExist: exist => ` ${exist} utenti già presenti in Recright.`,
      excel: 'Esporta tutti gli utenti',
    },

  },

}
